// src/data/newsData.ru.js
export const NEWS_RU = [
  {
    slug: "un-tax-proposal-on-cross-border-services-risks-backfiring",
    typeLabel: "Новости",
    taxonomy: "Налогообложение",
    dateLabel: "3 февраля 2026",
    title:
      "Налоговое предложение ООН по трансграничным услугам рискует обернуться против развивающихся экономик — показало новое исследование",
    excerpt:
      "Согласно новому исследованию Oxford Economics, подготовленному по заказу Международной торговой палаты (ICC), новая норма международного налогообложения, одобренная Комитетом экспертов ООН по налоговым вопросам, может подорвать рост и бюджетные доходы развивающихся экономик.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2026/02/Economic-impact-article-12AA.png?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2026/02/Economic-impact-article-12AA.png?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "Анализ показывает, что предлагаемое расширение прав страны-источника на налогообложение трансграничных услуг — статья 12AA Типовой налоговой конвенции ООН — может спровоцировать <strong>оценочную ежегодную потерю&nbsp;US$241 млн</strong> государственных доходов в развивающихся экономиках.",
      },
      {
        type: "p",
        html:
          "Норма позволяет странам вводить налоги у источника на любые трансграничные услуги даже в случаях, когда поставщик не имеет физического присутствия на рынке, и была принята без какого-либо сопутствующего анализа экономического воздействия, несмотря на потенциально далеко идущие последствия, распространяющиеся на все отрасли.",
      },
      {
        type: "quote",
        html:
          "Статья 12AA была принята без какой-либо серьёзной оценки её влияния на торговлю, инвестиции или рост. Наш анализ показывает, что, особенно для развивающихся экономик, более широкие экономические издержки могут существенно превысить собираемые доходы.",
        author: "Andrew Wilson, заместитель Генерального секретаря ICC по политике",
      },
      {
        type: "quote",
        html:
          "Трансграничные услуги — это не периферийная активность; это ключевой входной ресурс для современного производства, экспорта и интеграции в цепочки создания стоимости. Политика, повышающая их стоимость, рискует ослабить конкурентоспособность и замедлить диверсификацию.",
        author: "Andrew Wilson, заместитель Генерального секретаря ICC по политике",
      },
      {
        type: "p",
        html:
          "ICC призывает правительства с осторожностью подходить к принятию статьи 12AA и проводить надёжный анализ экономического воздействия нормы до включения её в двусторонние налоговые соглашения или принятия аналогичных положений на национальном уровне.",
      },
      {
        type: "mediaText",
        bgClass: "has-blue-700-background-color",
        media: {
          src: "https://iccwbo.org/wp-content/uploads/sites/3/2024/09/Icc-logo-full-download-bloc.png?w=295",
          alt: "",
        },
        heading: "Экономическое влияние статьи 12AA",
        cta: {
          label: "Скачать отчёт",
          href: "https://iccwbo.org/news-publications/report/economic-impact-of-article-12aa-new-un-tax-model-provision-on-cross-border-services/",
        },
      },
    ],
  },

  {
    slug:
      "icc-partners-with-leading-universities-to-launch-international-arbitration-module",
    taxonomy: "Службы разрешения споров",
    dateLabel: "16 января 2026",
    title:
      "ICC сотрудничает с ведущими университетами для запуска Международного арбитражного модуля",
    excerpt:
      "Службы разрешения споров ICC запустили партнёрство с университетами в Бразилии, Китае, Кении, Катаре и Чили, чтобы усилить обучение арбитражу.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2026/01/Climbing-Toward-Knowledge.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2026/01/Climbing-Toward-Knowledge.jpg?w=1080&h=1260&crop=1",
    },
    blocks: [
      {
        type: "p",
        html:
          "Международный арбитражный модуль ICC сначала будет внедрён в Wuhan University (Китай), Universidade de São Paulo (Бразилия), Hamad Bin Khalifa University (Катар), University of Nairobi (Кения) и Pontificia Universidad Católica de Chile (Чили); в ближайшие месяцы ожидается присоединение новых учреждений.",
      },
      {
        type: "p",
        html:
          "В то время как традиционные академические программы обычно сосредоточены на теоретических правовых рамках, Арбитражный модуль ICC добавит практический, прикладной компонент. Учебный план включает сценарии реальных дел, практические упражнения и специализированные публикации, призванные сократить разрыв между теорией и практикой.",
      },
      {
        type: "p",
        html:
          "Руслан Мирзаев, руководитель направления образования и обучения в Службах разрешения споров ICC, сказал:",
      },
      {
        type: "quote",
        html:
          "Через наше сотрудничество с университетами мы стремимся сделать знания об арбитраже более доступными по всему миру. При поддержке партнёрских университетов эта инициатива призвана дать будущим юристам практические арбитражные навыки, помочь им принимать обоснованные решения и обеспечить сторонам доступ к высококачественным юридическим услугам в разных частях мира.",
        author:
          "Ruslan Mirzayev, Head of Education and Training, ICC Dispute Resolution Services",
      },
      {
        type: "p",
        html:
          "Международный арбитражный модуль отражает приверженность ICC поддержке следующего поколения юридических практиков в развитии их навыков как специалистов по разрешению споров. Инициатива дополняет уже существующие и широкие программы ICC для студентов, включая ICC Vis Pre-Moot, ICC Mediation Competition, ICC Dispute Resolution Universities Programme и теперь — International Arbitration Module.",
      },
    ],
  },

  {
    slug: "powering-the-clean-energy-future-in-the-philippines",
    taxonomy: "Окружающая среда и устойчивое развитие",
    dateLabel: "16 декабря 2025",
    title: "Энергия чистого будущего на Филиппинах",
    excerpt:
      "Долгосрочная стратегия устойчивого развития Meralco прокладывает справедливый и доступный путь к будущему без угля к 2050 году.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/GettyImages-1357455726.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/GettyImages-1357455726.jpg?w=800&h=600&crop=1",
    },
    blocks: [
      {
        type: "mediaText",
        media: {
          src:
            "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/Photo-Meralco-Chief-Sustainability-Officer-Raymond-B.-Ravelo-1.png?w=250",
        },
        heading: "Raymond B. Ravelo",
        subheading: "Chief Sustainability Officer, Meralco",
      },
      {
        type: "p",
        html:
          "На фоне пересекающихся вызовов — изменения климата, быстрой урбанизации и роста неравенства — устойчивое развитие больше не может быть второстепенной целью: оно должно стать основой всего, что мы делаем.",
      },
      {
        type: "h3",
        text: "Наш план достижения 100% отказа от угля к 2050 году",
      },
      {
        type: "list",
        items: [
          "Горизонт 1 (2021–2030): активные инвестиции в возобновляемую энергетику с созданием мощностей более 1 500 МВт.",
          "Горизонт 2 (2031–2040): ускорение перехода через разработку и инвестиции в технологии следующего поколения.",
          "Горизонт 3 (2041–2050): глубокая декарбонизация через улавливание углерода и инициативы по углеродным поглотителям.",
        ],
      },
      {
        type: "p",
        html:
          "Вместе эти программы формируют план, который помогает городам и сообществам развиваться и процветать.",
      },
    ],
  },

  {
    slug:
      "how-brazils-renewable-power-is-fuelling-a-cleaner-future-for-transportation",
    taxonomy: "Климатические действия",
    dateLabel: "9 декабря 2025",
    title:
      "Как возобновляемая энергетика Бразилии ускоряет более чистое будущее транспорта",
    excerpt:
      "Чистая энергосистема Бразилии даёт ей уникальное преимущество в декарбонизации транспорта.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/Electric-charging-sustainability.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/Electric-charging-sustainability.jpg?w=1080&h=1260&crop=1",
    },
    blocks: [
      {
        type: "mediaText",
        media: {
          src:
            "https://iccwbo.org/wp-content/uploads/sites/3/2025/12/221108_Rodolfo_Sirol-thumbnail.png?w=250",
        },
        heading: "Rodolfo Nardez Sirol",
        subheading: "Environment and Sustainability Director, CPFL Energia",
      },
      {
        type: "h3",
        text: "Обилие возобновляемой энергии в Бразилии",
      },
      {
        type: "p",
        html:
          "Бразилия выделяется как одна из стран мира с наибольшей долей «зелёной» электроэнергии: почти 90% её генерации приходится на гидроэнергию, ветер и солнце.",
      },
      {
        type: "h2",
        text: "Наша приверженность масштабированию успеха",
      },
      {
        type: "p",
        html:
          "Электрификация автопарка для CPFL Energia — это больше, чем технологическое обновление: это краеугольный камень ESG-стратегии компании.",
      },
    ],
  },

  {
    slug:
      "women-led-agribusinesses-are-trailblazing-climate-solutions-in-africa",
    taxonomy: "Климатические действия",
    dateLabel: "28 ноября 2025",
    title:
      "Агробизнесы под руководством женщин прокладывают путь климатическим решениям в Африке",
    excerpt:
      "Робинн Андерсон делится историями женщин-агрипредпринимателей, которые продвигают климатические действия по всей Африке.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/icc-orange-header.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/icc-orange-header.jpg?w=800&h=534&crop=1",
    },
    blocks: [
      {
        type: "mediaText",
        media: {
          src:
            "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/Robynne-Anderson-thumbnail.png?w=250",
        },
        heading: "Robynne Anderson",
        subheading: "President, EmergingAg",
      },
      {
        type: "h2",
        text: "Как женщины-агрипредприниматели усиливают климатические действия",
      },
      {
        type: "p",
        html:
          "Женщины-агрипредприниматели по всей Африке восстанавливают земли, сокращают пищевые потери и формируют устойчивые продовольственные системы.",
      },
      {
        type: "h2",
        text: "В Мали Herou Alliance восстанавливает земли и источники дохода",
      },
      {
        type: "p",
        html:
          "Herou Alliance высадила более 2 000 деревьев моринги, внося вклад в лесовосстановление и устойчивые средства к существованию.",
      },
    ],
  },

  {
    slug: "agricultural-transformation-starts-from-the-soil-up",
    taxonomy: "Климатические действия",
    dateLabel: "24 ноября 2025",
    title: "Аграрная трансформация начинается с почвы",
    excerpt:
      "OCP Group продвигает аграрную трансформацию через устойчивые решения по питанию почв.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/icc-agriculture-ground-soil.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/icc-agriculture-ground-soil.jpg?w=800&h=533&crop=1",
    },
    blocks: [
      {
        type: "mediaText",
        media: {
          src:
            "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/Meriem-El-Asraoui-thumbnail.png?w=250",
        },
        heading: "Meriem El Asraoui",
        subheading: "Chief Global Affairs Officer, OCP Group",
      },
      {
        type: "h2",
        text: "Устойчивые питательные вещества почвы как основа трансформации",
      },
      {
        type: "p",
        html:
          "Почва — живая основа сельского хозяйства и отправная точка для климатически позитивной трансформации.",
      },
      {
        type: "h2",
        text: "Мы инвестируем US$13 млрд в «зелёную» индустриальную стратегию",
      },
      {
        type: "list",
        items: [
          "Производство «зелёного» аммиака на базе возобновляемых источников энергии",
          "Переход на 100% ветровую и солнечную энергию к 2027 году",
          "Нулевые выбросы по всей цепочке создания стоимости к 2040 году",
          "Использование 100% нетрадиционных источников воды",
        ],
      },
    ],
  },

  {
    slug: "flying-towards-a-net-zero-future",
    taxonomy: "Климатические действия",
    dateLabel: "4 ноября 2025",
    title: "К полётам в будущее с нулевыми выбросами",
    excerpt:
      "Декарбонизация авиации — колоссальный вызов, но и шанс всей жизни переосмыслить то, как мы путешествуем. Путь к net zero приведёт к самолётам на новых тяговых системах, более электрическим конструкциям и устойчивому авиационному топливу (SAF). Халдейн Додд, исполнительный директор Air Transport Action Group (ATAG), призывает к дальнейшим совместным действиям: масштабировать производство SAF, ускорять внедрение более топливоэффективных самолётов и инвестировать в технологии следующего поколения — чтобы авиация продолжала обеспечивать глобальную связанность и одновременно помогала защитить планету для будущих поколений.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/Air-Transport-Action-Group.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/Air-Transport-Action-Group.jpg?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "mediaText",
        bgClass: "has-grey-250-background-color",
        media: {
          src: "https://iccwbo.org/wp-content/uploads/sites/3/2025/11/haldane-dodd-thumbnail.png?w=250",
          alt: "",
        },
        heading: "Haldane Dodd",
        subheading: "Executive Director • Air Transport Action Group",
      },
      {
        type: "p",
        html:
          "Изменение климата — определяющий вопрос нашего времени. Оно влияет на окружающую среду множеством способов: от повышения уровня моря и последствий деградации вечной мерзлоты до высоких температур и наводнений из-за более мощных штормов и прибрежной эрозии. Каждая отрасль пересматривает свои операции, вынуждена внедрять инновации и действовать решительно. Для авиации — сектора, который не только соединяет более 4 миллиардов людей ежегодно и обеспечивает почти 4% мировой экономической активности, но и даёт порядка 2% глобальных выбросов углерода, — необходимость декарбонизации ещё более срочная.",
      },
      {
        type: "p",
        html:
          "Именно поэтому глобальная отрасль воздушного транспорта работает над достижением нулевых выбросов углерода к 2050 году. Да, декарбонизация сектора, столь зависящего от ископаемого топлива, — огромный вызов, но это также шанс, позволяющий переосмыслить то, как мы будем путешествовать в не столь далёком будущем: самолёты будут оснащаться новыми системами тяги, которые снижают расход топлива или опираются на более электрические архитектуры, а устойчивое авиационное топливо (SAF) должно будет обеспечивать большинство взлётов по всему миру.",
      },
      {
        type: "p",
        html:
          "Одновременно более умное и эффективное управление воздушным пространством, а также инфраструктура и операции аэропортов преобразят авиаперелёты. Вызов всей нашей жизни — достичь net zero — это шанс всей нашей жизни создать следующее поколение воздушного транспорта!",
      },

      { type: "h2", text: "Превращая возможность в реальность" },

      {
        type: "p",
        html:
          "Это не просто амбиция. Трансформация авиации к net zero уже идёт — правительства под эгидой Международной организации гражданской авиации (ICAO) поддерживают цель 2050 года. Авиакомпании, аэропорты, производители, провайдеры аэронавигации и вся цепочка создания стоимости воздушного транспорта предпринимают действия по снижению выбросов углерода.",
      },
      {
        type: "p",
        html:
          "Но путь к цели сложен и требует огромных усилий от всех заинтересованных сторон. Не существует «серебряной пули» для net zero; разные стейкхолдеры и регионы будут вносить вклад по-разному. Одни будут лидировать за счёт масштабного внедрения SAF, другие станут первопроходцами в водородных, гибридных и электрических системах тяги. Вместе эти усилия сходятся в одном общем путешествии: превращении образа завтрашнего полёта в реальность сегодняшнего дня.",
      },
      {
        type: "p",
        html:
          "В основе этой трансформации — переход от ископаемого топлива к более чистым источникам энергии. SAF, который можно производить из таких ресурсов, как отработанные масла, сельскохозяйственные остатки, водоросли или даже уловленный углерод, способен снизить выбросы за жизненный цикл до 80%.&nbsp;Но проблема — в масштабировании: сегодня это топливо составляет менее 1% глобального потребления авиационного керосина. Чтобы достичь целей 2050 года, производство должно расти экспоненциально, что требует создания совершенно новой энергетической экосистемы. Это означает новые НПЗ и цепочки поставок, а также гармонизированное регулирование по всему миру и инвестиционные и финансовые рамки.",
      },
      {
        type: "embed",
        html:
          '<div class="flourish-embed fl-scrolly-wrapper" data-src="story/3419253?2927799"><script src="https://public.flourish.studio/resources/embed.js"></script><noscript><img decoding="async" src="https://public.flourish.studio/story/3419253/thumbnail" width="100%" pxalt="visualization" /></noscript><iframe scrolling="no" frameborder="0" title="Interactive or visual content" sandbox="allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation" style="width: 100%; height: 80vh;" src="https://flo.uri.sh/story/3419253/embed?auto=1"></iframe></div>',
      },

      { type: "h2", text: "Создавая экосистему для трансформации" },

      {
        type: "p",
        html:
          "Air Transport Action Group(ATAG) поддерживает отрасль в достижении целей net zero. Организации-участники разделяют видение: воздушный транспорт должен продолжать соединять мир и поддерживать экономическое и социальное развитие в ближайшие десятилетия, соблюдая обязательства по климатическим действиям. Кейсы, выделенные в этом выпуске рассылки организациями вроде Airports Council International и производителями SAF LanzaJet и World Energy, показывают, как авиационная отрасль сотрудничает, включая производителей SAF, чтобы приблизиться к цели.",
      },
      {
        type: "p",
        html:
          "Это показывает, что наши общие усилия вовсе не ограничиваются только авиацией. Мы не можем декарбонизировать в вакууме; нам нужно взаимодействовать с бизнес-сообществом вне авиационного сектора, чтобы создавать возможности для климатического эффекта. Помимо финансового и энергетического секторов, это включает бизнес в технологиях и строительстве, а также стартапы и исследовательских партнёров — чтобы внедрять инновации и масштабировать новые решения.",
      },

      { type: "h2", text: "Следующие пять лет определят будущее полётов" },

      {
        type: "p",
        html:
          "Одно ясно: у нас есть возможность создать net zero-будущее для воздушного транспорта, но времени мало. Следующие пять лет будут решающими, и каждый год задержки делает net zero труднее и дороже. Сейчас — время совместно принять этот вызов: масштабировать глобальное производство SAF, продолжать внедрение рыночных механизмов и финансовых инструментов, быстрее вводить в парк более топливоэффективные самолёты и продолжать исследования и разработки новых технологий тяги.",
      },
      {
        type: "p",
        html:
          "Мы должны продолжать модернизировать системы управления воздушным движением и ускорять развитие и масштабирование технологий удаления углерода. Это важно не только для планеты, но и для защиты роли авиации как драйвера глобальной связанности, торговли, туризма и экономических возможностей для сообществ по всему миру.",
      },
      {
        type: "p",
        html:
          "Декарбонизация авиации может стать символом того, чего способны добиться многостороннее сотрудничество и инновации, когда мир работает вместе ради общей цели. Это не просто вызов. Это действительно шанс всей жизни — переопределить то, как воздушный транспорт соединяет мир, и помочь защитить планету для будущих поколений.",
      },

      { type: "hr" },

      {
        type: "p",
        html:
          "<em>2025 год — критический для Парижского соглашения. Спустя десять лет нам нужно переосмыслить, как мы формулируем этот вызов. И видеть вызовы иначе — это то, чем занимается бизнес и чем занимаемся все мы.</em>",
      },
      {
        type: "p",
        html:
          '<em>ICC стремится обеспечить то, что нужно бизнесу, на предстоящих климатических переговорах COP30 в Белене, Бразилия. Узнайте больше о нашей&nbsp;</em><a href="https://iccwbo.org/global-insights/sustainability-and-climate-action/thebusinessofclimate/"><em>Opportunity of a Lifetime</em></a><em>&nbsp;климатической кампании и о том, как присоединиться.</em>',
      },
      {
        type: "p",
        html:
          "<em>*Дисклеймер: содержание этой статьи может не отражать официальные взгляды Международной торговой палаты. Высказанные мнения принадлежат исключительно авторам и другим участникам.</em>&nbsp;",
      },
    ],
  },

  {
    slug:
      "from-technological-progress-to-tackling-the-mounting-challenge-of-electronic-waste",
    taxonomy: "Климатические действия",
    dateLabel: "27 октября 2025",
    title:
      "От технологического прогресса — к решению растущей проблемы электронных отходов",
    excerpt:
      "Электроника изменила современную жизнь, но её «посмертие» рассказывает другую историю — нарастающий кризис e-waste, ныне самый быстрорастущий поток отходов на Земле, из которых правильно перерабатывается менее четверти. Это не только неустойчиво, но и упущенная возможность: ежегодно выбрасываются миллиарды долларов в виде извлекаемых материалов. Томазо Манка из Hiro Robotics показывает, что те же технологии, которые движут быстрыми инновациями, могут помочь замкнуть цикл. Робототехника и искусственный интеллект способны разбирать устройства, извлекать и повторно использовать ценные компоненты, питающие наш цифровой мир.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/icc-robotic-industrie-e1761557376559.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/icc-robotic-industrie-e1761557376559.jpg?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "mediaText",
        bgClass: "has-grey-250-background-color",
        media: {
          src: "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/Tomaso-thumbnail-icc-guestblog.png?w=523",
          alt: "",
        },
        heading: "Tomaso Manca",
        subheading: "Marketing and Communication Manager • Hiro Robotics",
      },
      {
        type: "p",
        html:
          "За последние десятилетия электроника преобразила нашу жизнь. Устройства стали меньше, умнее и более взаимосвязанными, изменив то, как мы работаем, общаемся и живём. Однако один ключевой вопрос остаётся во многом без ответа: что происходит, когда технология достигает конца своего жизненного цикла?",
      },
      {
        type: "p",
        html:
          "Пока инновации развивались с молниеносной скоростью, подход к обращению с устаревшими устройствами за ними не поспевал. Результат — быстро растущая экологическая и экономическая проблема: электронные отходы.",
      },
      {
        type: "p",
        html:
          "Согласно Global E-Waste Monitor 2024, человечество произвело 62 млн тонн электронных отходов в 2022 году — рост на 82% по сравнению с 2010 годом. Лишь 22,3% этих отходов были официально собраны и переработаны экологически безопасным образом. Остальное было захоронено, сожжено или переработано неформально.",
      },
      {
        type: "p",
        html:
          "Электронные отходы сейчас — самый быстрорастущий поток отходов в мире, увеличивающийся примерно в пять раз быстрее, чем документированная перерабатывающая мощность. Чтобы это представить, ежегодная «куча» выброшенной электроники заполнила бы примерно 1,55 млн грузовиков, выстроившись линией вокруг экватора Земли.",
      },
      {
        type: "p",
        html:
          "Помимо объёма, скрытая опасность — в токсичных веществах: ртуть, свинец, кадмий, бромированные антипирены — которые вредят работникам, загрязняют почву и воду и попадают в пищевые цепочки. Сообщества рядом с неформальными центрами переработки, такими как Агбогблоши в Гане, продолжают сталкиваться с серьёзными рисками для здоровья, включая респираторные заболевания и отравление тяжёлыми металлами.",
      },
      {
        type: "p",
        html:
          "Одновременно электронные отходы содержат огромную неиспользованную ценность. Монитор 2024 оценивает, что выброшенная электроника включала извлекаемые материалы на сумму US$ 91 млрд — от золота и меди до редкоземельных элементов — из которых сейчас извлекается лишь около US$ 28 млрд в год. Следовательно, в самой проблеме скрыто и её решение.",
      },

      { type: "h2", text: "Создавая условия для изменений" },

      {
        type: "p",
        html:
          "Эффективное решение проблемы электронных отходов требует больше, чем одной технологии. Оно зависит от взаимодействия пяти ключевых опор: регулирования, инфраструктуры, экономической жизнеспособности, рыночных настроений и сотрудничества.",
      },

      { type: "h3", text: "1. Эффективное и ориентированное на будущее регулирование" },
      {
        type: "p",
        html:
          "Надёжные политические рамки — такие как Директива ЕС по отходам электрического и электронного оборудования (WEEE) и схемы расширенной ответственности производителя (EPR) — закладывают основу для ответственности и инноваций. Однако регулирование должно эволюционировать дальше целей по сбору. Оно должно стимулировать проектирование для разборки, модульность и прослеживаемые процессы переработки, которые делают обработку в конце жизненного цикла одновременно осуществимой и прибыльной.",
      },

      { type: "h3", text: "2. Инфраструктура, связывающая каждый этап" },
      {
        type: "p",
        html:
          "Даже лучшая технология переработки бесполезна без надёжного потока материалов. Странам нужна распределённая сеть пунктов сбора и предварительной обработки, которые смогут агрегировать и сортировать устройства до отправки на специализированные перерабатывающие предприятия. Оптимизированная логистика снижает затраты, уменьшает выбросы и обеспечивает локальный эффект масштаба.",
      },

      { type: "h3", text: "3. Жизнеспособная экономическая модель" },
      {
        type: "p",
        html:
          "Переработка будет развиваться только если это экономически оправдано. Баланс зависит от множества факторов: стабильных цен на вторичное сырьё, учёта экологических издержек загрязняющих альтернатив, растущего спроса на сертифицированные переработанные компоненты и модульных технологий, которые можно адаптировать к разным категориям отходов.",
      },
      {
        type: "p",
        html:
          "Когда эти силы совпадают, циркулярные инновации становятся самоподдерживающимися, а не субсидируемыми.",
      },

      { type: "h3", text: "4. Рыночные настроения и ответственная закупка" },
      {
        type: "p",
        html:
          "Корпоративные покупатели и государственные органы обладают значительным влиянием. Требуя прозрачности, прослеживаемости и доли переработанного сырья в закупаемой продукции, они могут изменить экономику извлечения. Закупки способны запустить культурный сдвиг: управление отходами перестаёт быть лишь регуляторной обязанностью и становится конкурентным преимуществом.",
      },

      { type: "h3", text: "5. Межсекторное сотрудничество" },
      {
        type: "p",
        html:
          "Ни один актор не способен в одиночку решить кризис электронных отходов. Правительства, производители, переработчики и исследовательские институты должны сотрудничать, чтобы создавать открытые стандарты, делиться данными и совместно инвестировать в пилотные проекты. Такой подход превращает разрозненные усилия в целостную систему — способную масштабировать и инновации, и эффект.",
      },
      {
        type: "p",
        html:
          "Когда эти пять элементов уравновешивают друг друга, технология наконец получает плодородную почву для устойчивых изменений.",
      },

      { type: "h2", text: "Превращая робототехнику и ИИ в инструменты циркулярности" },

      {
        type: "p",
        html:
          "В Hiro Robotics мы считаем, что технологии, изначально созданные для производства новых продуктов, могут — и должны — быть адаптированы для их разборки по окончании срока службы.",
      },
      {
        type: "p",
        html:
          "Сегодня большинство электронных отходов либо разбирается вручную — медленно и рискованно для операторов — либо без разбора измельчается, что разрушает ценные компоненты и смешивает опасные материалы. Робототехника и искусственный интеллект предлагают третий путь: выборочную, интеллектуальную разборку.",
      },
      { type: "p", html: "Этот подход лежит в основе исследований и промышленных систем Hiro:" },

      {
        type: "list",
        items: [
          "<strong>Hiro TEIA</strong> разбирает плоские панели, такие как телевизоры и мониторы, автоматизируя одну из самых деликатных и опасных задач переработки.",
          "<strong>Hiro MAIA</strong> выкручивает крепёж и разделяет промышленные и телеком-устройства, такие как серверы и сетевые модули, извлекая компоненты в целости.",
          "<strong>Hiro NISA</strong> использует компьютерное зрение и ИИ-сортировку для классификации печатных плат по материалу и остаточной стоимости.",
        ],
      },

      {
        type: "p",
        html:
          "Каждая система переводит философию циркулярного дизайна в промышленную практику: максимизируя извлечение, минимизируя риск и предоставляя данные для прослеживаемости материалов.",
      },
      {
        type: "p",
        html:
          "Наша команда R&amp;D продолжает расширять эти методы на более сложные продукты, такие как батареи электромобилей и плотно герметизированные потребительские устройства. Однако даже при наличии передовых технологий успех зависит от более широкого согласования: компании должны быть готовы эволюционировать свои процессы, а законодатели — создавать рамки, которые вознаграждают устойчивый переход.",
      },

      { type: "h2", text: "За пределами «тёмной стороны» технологий" },

      {
        type: "p",
        html:
          "Электронные отходы часто воспринимаются как тёмная сторона прогресса — следствие нашей жажды инноваций. Но технология сама по себе не враг. При разумном регулировании, умной инфраструктуре, здравой экономике и межсекторном сотрудничестве технология может стать ключевой частью решения.",
      },
      {
        type: "p",
        html:
          "Робототехника и ИИ помогают иначе увидеть отходы: не как побочный продукт потребления, а как поток ресурсов, которым можно управлять интеллектуально.",
      },
      {
        type: "p",
        html:
          "Глобальный вызов электронных отходов огромен — 62 млн тонн и рост — но столь же велика и возможность. Если мы будем действовать совместно, та же изобретательность, которая создала наш цифровой мир, поможет его «починить»: превратив выброшенную электронику в сырьё для по-настоящему циркулярного будущего.",
      },

      { type: "hr" },

      {
        type: "p",
        html:
          "<em>2025 год — критический для Парижского соглашения. Спустя десять лет нам нужно переосмыслить, как мы формулируем этот вызов. И видеть вызовы иначе — это то, чем занимается бизнес и чем занимаемся все мы.</em>",
      },
      {
        type: "p",
        html:
          '<em>ICC стремится обеспечить то, что нужно бизнесу, на предстоящих климатических переговорах COP30 в Белене, Бразилия. Узнайте больше о нашей&nbsp;</em><a href="https://iccwbo.org/global-insights/sustainability-and-climate-action/thebusinessofclimate/"><em>Opportunity of a Lifetime</em></a><em>&nbsp;климатической кампании и о том, как присоединиться.</em>',
      },
      {
        type: "p",
        html:
          "<em>*Дисклеймер: содержание этой статьи может не отражать официальные взгляды Международной торговой палаты. Высказанные мнения принадлежат исключительно авторам и другим участникам.</em>&nbsp;",
      },
    ],
  },

  {
    slug: "the-future-of-energy-is-built-on-new-business-models-not-just-new-tech",
    taxonomy: "Окружающая среда и устойчивое развитие",
    dateLabel: "20 октября 2025",
    title: "Будущее энергетики строится на новых бизнес-моделях, а не только на новых технологиях",
    excerpt:
      "Рост спроса на электроэнергию перегружает энергосеть XX века, построенную для другого мира. Кит Норман, Chief Sustainability Officer в Lyten, утверждает, что энергетический переход зависит от новых бизнес-моделей, а не только от новых технологий. От децентрализованного накопления энергии до литий-серных батарей с 85% «без добычи» — Lyten переосмысливает энергетическую инфраструктуру, чтобы обеспечить изобильную и более чистую энергию для XXI века.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/icc-battery-dark.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/icc-battery-dark.jpg?w=800&h=494&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "mediaText",
        bgClass: "has-grey-250-background-color",
        media: {
          src: "https://iccwbo.org/wp-content/uploads/sites/3/2025/10/keith-photo-guest-blog.png?w=524",
          alt: "",
        },
        heading: "Keith Norman",
        subheading: "Chief Sustainability Officer • Lyten",
      },

      {
        type: "h2",
        text:
          "Кит, мир сталкивается с тем, что вы назвали «самым большим наращиванием потребления электроэнергии за всю историю». Как Lyten воспринимает этот всплеск спроса — как риск или как стратегическую возможность?",
      },
      {
        type: "p",
        html:
          "<strong>Keith</strong>: Риск и возможность — две стороны одной медали. Глобальный спрос на электроэнергию почти удвоится в следующие 25 лет из-за ИИ/дата-центров и развивающихся экономик, на которые, по прогнозам, придётся примерно 80% прироста к 2040 году.&nbsp;",
      },
      {
        type: "p",
        html:
          "Реалистично, чтобы удовлетворить этот спрос, потребуется «портфель всего сразу», включая ископаемое топливо и ВИЭ. Но реальная проблема — в распределении. Расширение линий передачи — медленный и дорогостоящий процесс, увязший в многолетних разрешительных процедурах.&nbsp;",
      },
      {
        type: "p",
        html:
          "Риск определяется бездействием и работой в рамках наследуемых моделей коммерциализации, финансирования, разрешительных процедур и политики. Технологических инноваций недостаточно. Лучший аналог из моей жизни — переход на сотовую связь. Целые континенты с минимальной связью через стационарные линии были подключены за десятилетие не потому, что мы построили больше «проводов», а потому что сотовая технология создала совершенно новую модель. Нам нужно такое же мышление в энергетике. Возможность — в проактивных, совместных действиях по энергетическому переходу.&nbsp;",
      },

      { type: "spacer", px: 20 },

      {
        type: "h2",
        text:
          "Вы завершаете призывом к новой модели энергетики. Каковы ключевые ограничения старой модели и как стратегия Lyten даёт путь вперёд?",
      },
      {
        type: "p",
        html: "<strong>Keith</strong>: Мы видим две большие возможности.&nbsp;&nbsp;",
      },
      {
        type: "p",
        html:
          "<strong>Первая — это сеть.</strong> На стороне генерации ВИЭ быстро растут, но зависимость от сети мешает полностью вводить эти мощности в работу. Наша сеть проектировалась под стабильные централизованные электростанции, а ей трудно справляться с переменной и децентрализованной природой современных ВИЭ. Это несоответствие создаёт узкие места, вынуждая нас «терять» чистую энергию, потому что она не может попасть в нужное место в нужное время.&nbsp;",
      },
      {
        type: "p",
        html:
          "Мы считаем, что важная часть решения — добавление децентрализованных накопителей энергии на «краю» сети, там, где электричество потребляется. Это обход узких мест и превращение ВИЭ в надёжный источник 24/7, выводя батареи из категории «климат-теха» в критическую энергетическую инфраструктуру. По данным энергетического отчёта ExxonMobil за 2024 год, миру потребуется масштабировать дополнительную генерацию на 20 000 ТВт⋅ч к 2050 году. Для сравнения: это эквивалентно двум третям текущего мирового объёма, который, как сообщает Ember Energy, наконец превысил 30 000 ТВт⋅ч в 2024 году после более чем века. Прогнозируется, что ВИЭ плюс батареи обеспечат 85% этого нового спроса. Поэтому мы крайне оптимистично оцениваем роль батарей на десятилетия вперёд: они ключ к обеспечению перехода, предоставляя более чистую энергию там и тогда, где она нужна больше всего.&nbsp;",
      },
      {
        type: "p",
        html:
          "<strong>Вторая возможность — цепочка поставок.</strong> Сегодня батареи зависят от масштабной добычи и переработки минералов. Чтобы достичь целей перехода, Benchmark Minerals предполагают, что нам понадобилось бы порядка 400 новых шахт за десятилетие. Это нереалистично и экологически разрушительно. Ситуацию усугубляет геополитическая концентрация цепочки поставок батарей: материалы совершают «глобальный тур» на 50 000 миль для переработки и сборки, концентрируя риск, стоимость и углерод в продукте, который должен быть устойчивым. Мы видели похожее на примере солнечных панелей, где региональные монополии привели к сегодняшним глубоким зависимостям в PV.&nbsp;&nbsp;",
      },
      {
        type: "p",
        html:
          "<strong>Подход Lyten — убрать добываемые минералы из цепочки поставок батарей.</strong> Наша литий-серная батарея устраняет около 85% содержания «добытых» минералов, включая никель, кобальт, марганец и графит. Мы видим путь к батареям с более чем 90% «без добычи» за счёт лития из рассолов. Переход к обильным, локально доступным материалам — способ сделать скачок вперёд. Мы считаем, что литий-серная химия будет лидировать: это более энергоёмкая батарея, использующая более дешёвые материалы и радикально диверсифицирующая и укрепляющая нашу цепочку поставок.",
      },

      { type: "spacer", px: 20 },

      {
        type: "h2",
        text:
          "Видение Lyten выходит далеко за пределы энергетики. Можете привести ещё один пример того, как Lyten работает со сложными для декарбонизации секторами?",
      },
      {
        type: "p",
        html:
          "<strong>Keith</strong>: Конечно. Мы также используем нашу платформу материалов для декарбонизации физической инфраструктуры. Яркий пример — бетон. Цемент — крупная климатическая проблема, на него приходится 8% глобальных выбросов CO2. Мы решаем это новой добавкой, которая делает бетон на 30% прочнее. Это даёт два эффекта: повышенная прочность увеличивает срок службы инфраструктуры и, что критично, позволяет использовать заметно меньше цемента, снижая углеродный след.&nbsp;",
      },
      {
        type: "p",
        html:
          "Мы уже видим высокий спрос, потому что продукт решает ключевые проблемы клиентов — производительность и стоимость. Это подтверждает нашу базовую идею: чтобы устойчивое решение стало массовым, оно должно быть прежде всего более эффективным и более экономичным вариантом. Для строителей более прочная инфраструктура с меньшим объёмом цемента — экономическая выгода. Снижение CO2 — важный сопутствующий эффект. В этом сила наших материаловных инноваций: они работают в разных отраслях — от батарей до строительства.&nbsp;",
      },

      { type: "spacer", px: 20 },

      {
        type: "h2",
        text:
          "Смотрим вперёд: какое одно ключевое сообщение вы хотели бы донести до мирового бизнеса и политических лидеров?",
      },
      {
        type: "p",
        html:
          "<strong>Keith:</strong> Нам нужно выйти за рамки старых способов мышления. Даже при росте ВИЭ и батарей энергетическая инфраструктура 75 лет опиралась на одну и ту же централизованную модель, и этого уже недостаточно. Обеспечение более чистой и надёжной электроэнергии потребует инноваций не только в технологиях, но и в бизнес-моделях, финансировании и политике.&nbsp;",
      },
      {
        type: "p",
        html:
          "В Lyten мы уже видим, как сочетание новых батарейных систем с креативным финансированием открывает совершенно новые рынки. Невероятный спрос на наши системы накопления энергии в развивающихся экономиках был бы невозможен без поддерживающей финансовой модели, которую мы получили от Export-Import Bank США. Одна технология не решит переход. Масштабируемое финансирование меняет всё.&nbsp;",
      },
      {
        type: "p",
        html:
          "Единственное сообщение, которое я хотел бы оставить мировому бизнесу и политикам: энергетический переход — это не просто замена топлива; это перепроектирование системы, чтобы обеспечить изобильную, чистую энергию. Нам нужны лидеры, которые способны мыслить творчески вдоль всей цепочки создания стоимости — от материаловедения до проектного финансирования, партнёрств и политики. Инкрементальные улучшения помогают, но их недостаточно; нам нужны смелые обязательства, которые окупаются не только в следующем квартале, но и на десятилетия вперёд.&nbsp;&nbsp;",
      },

      { type: "hr" },

      {
        type: "p",
        html:
          "<em>2025 год — критический для Парижского соглашения. Спустя десять лет нам нужно переосмыслить, как мы формулируем этот вызов. И видеть вызовы иначе — это то, чем занимается бизнес и чем занимаемся все мы.</em>&nbsp;",
      },
      {
        type: "p",
        html:
          '<em>ICC стремится обеспечить то, что нужно бизнесу, на предстоящих климатических переговорах COP30 в Белене, Бразилия. Узнайте больше о нашей </em><a href="https://iccwbo.org/global-insights/sustainability-and-climate-action/thebusinessofclimate/" target="_blank" rel="noreferrer noopener"><em>Opportunity of a Lifetime</em></a><em> климатической кампании и о том, как присоединиться.</em>&nbsp;',
      },
      {
        type: "p",
        html:
          "<em>*Дисклеймер: содержание этой статьи может не отражать официальные взгляды Международной торговой палаты. Высказанные мнения принадлежат исключительно авторам и другим участникам.</em>&nbsp;&nbsp;&nbsp;",
      },
    ],
  },

  {
    slug: "the-compliance-divide-how-ai-can-close-the-gap-between-policy-and-producers",
    taxonomy: "Климатические действия",
    dateLabel: "16 сентября 2025",
    title: "Разрыв в комплаенсе: как ИИ может сократить дистанцию между политикой и производителями",
    excerpt:
      "Понимание сложных правил в сфере окружающей среды и устойчивого развития может определять, будете ли вы исключены с рынков или станете частью климатического перехода. В этом гостевом блоге Ники Льюис, Chief Sustainability Officer в Bext360, показывает, как их новый ИИ-инструмент может превращать плотные регуляторные тексты в простые задачи, ориентированные на мобильные устройства, давая малым производителям и кооперативам шанс оставаться подключёнными к глобальным рынкам, а брендам и регуляторам — получать достоверные данные.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/09/icc-ia-smes-sustainability.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2025/09/icc-ia-smes-sustainability.jpg?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "mediaText",
        bgClass: "has-grey-250-background-color",
        media: {
          src: "https://iccwbo.org/wp-content/uploads/sites/3/2025/09/niki-lewis-round-hs.png?w=308",
          alt: "",
        },
        content: "<strong>Niki Lewis</strong><br/>Chief Sustainability Officer at Bext360",
      },
      {
        type: "p",
        html:
          "Когда политики в Брюсселе разрабатывают новые правила устойчивого развития, намерение ясно: привлекать компании к ответственности за экологическое и социальное воздействие. Регламент ЕС о вырубке лесов (EUDR) и Директива по корпоративной отчётности в области устойчивого развития (CSRD) — последние примеры лидерства Европы в климатической политике. Но для миллионов мелких фермеров в Латинской Америке, Африке и Азии эти законы могут ощущаться не как прогресс, а как барьер.",
      },
      {
        type: "p",
        html:
          "Неприятная правда в том, что даже благие регуляции рискуют «вытолкнуть» производителей с мировых рынков, если мы не сократим разрыв в комплаенсе.",
      },
      { type: "h2", text: "Взгляд производителя" },
      {
        type: "p",
        html:
          "Для бренда в Европе комплаенс — это обязанность. Для производителя в Эфиопии, Гондурасе или на Мадагаскаре комплаенс — это «паспорт» в мировую экономику. Без него их продукцию нельзя продать.",
      },
      {
        type: "p",
        html:
          "Но у большинства производителей нет комплаенс-офицеров или юридических команд. У них нет ресурсов, чтобы интерпретировать сотни страниц права ЕС. У них нет GIS-экспертов для картирования ферм или аудиторов для документирования каждого трудового договора. Зато у них есть мобильные телефоны, нестабильный интернет и острая необходимость продолжать экспортировать культуры, от которых зависит их благополучие.",
      },
      { type: "h2", text: "Сокращаем разрыв с помощью ИИ" },
      {
        type: "p",
        html:
          "Именно здесь технологии могут стать разницей между включением и исключением. В Bext360 мы разработали ИИ-инструмент комплаенса Ethica, который берёт плотный текст регуляций вроде EUDR и превращает его в выполнимые задачи для производителей.",
      },
      {
        type: "p",
        html:
          "Вместо того чтобы просить фермера «доказать происхождение без вырубки лесов», система просит загрузить GPS-полигон его участка. Вместо длинного социального отчёта платформа предлагает кооперативу зафиксировать базовые трудовые данные через мобильную форму. Каждая запись получает отметку времени, геометку и неизменно хранится в блокчейне.",
      },
      {
        type: "p",
        html:
          "Для фермера задача занимает минуты. Для бренда это создаёт проверяемую запись комплаенса. Для регуляторов — даёт достоверные данные, которые им нужны.",
      },
      { type: "h2", text: "Закрывая разрыв" },
      {
        type: "p",
        html:
          "Чтобы законодательство об устойчивом развитии сработало, оно должно сокращать дистанцию между политикой и практикой. Платформы комплаенса на базе ИИ — один из немногих способов сделать это в масштабе.",
      },
    ],
  },

  {
    slug: "how-is-biodiversity-shaping-the-future-of-business",
    taxonomy: "Новости",
    dateLabel: "22 мая 2025",
    title: "Как биоразнообразие формирует будущее бизнеса?",
    excerpt:
      "В Международный день биоразнообразия мы отвечаем на три ключевых вопроса, вдохновлённых темой этого года — «Гармония с природой и устойчивое развитие».",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2024/11/GettyImages-1405452705.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2024/11/GettyImages-1405452705.jpg?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      { type: "h2", text: "Возможен ли бизнес без биоразнообразия?" },
      {
        type: "p",
        html:
          "Нет. Биоразнообразие лежит в основе нашего общего выживания, благополучия и мировой экономики.",
      },
      {
        type: "p",
        html:
          "Согласно исследованиям, более половины мирового ВВП умеренно или сильно зависит от природы и того, что она предлагает.",
      },
      {
        type: "p",
        html:
          "Хорошая новость в том, что критически важная роль природы всё чаще признаётся в решениях, которые принимают компании и финансовые институты — в их операциях, цепочках создания стоимости и инвестициях.",
      },
      {
        type: "h2",
        text: "Как экономическое развитие и сохранение природы могут идти рука об руку?",
      },
      {
        type: "p",
        html:
          "Один из способов одновременно поддерживать экономическое развитие и сохранять природную среду — продвигать устойчивое использование биоразнообразия, что является ключевой опорой Конвенции о биологическом разнообразии (CBD).",
      },
      {
        type: "columns",
        columns: [
          [
            {
              type: "p",
              html:
                "<strong>Компании</strong> всё чаще ищут способы создавать экономические возможности и одновременно выполнять свою ответственность перед обществом и окружающей средой.",
            },
          ],
          [
            {
              type: "p",
              html:
                "<strong>А что могут сделать правительства?</strong><br/>Правительства могут разрабатывать поддерживающие политики, которые помогают компаниям адаптировать операции и стратегии так, чтобы биоразнообразие сохранялось.",
            },
          ],
        ],
      },
      {
        type: "quote",
        html:
          "<strong>Бизнес может и должен быть частью решения, чтобы находить пути, обеспечивающие устойчивое экономическое развитие в гармонии с природой.</strong>",
      },
      { type: "h2", text: "И какова роль исследований и инноваций?" },
      {
        type: "p",
        html:
          "Исследования и инновации — один из способов устойчиво использовать биоразнообразие для разработки знаний и решений, которые помогают справляться с общественными и экологическими вызовами.",
      },
      {
        type: "p",
        html:
          "Как институциональный представитель более 45 миллионов компаний по всему миру, ICC работает с правительствами и другими стейкхолдерами над созданием рамок, позволяющих компаниям делиться выгодами от использования биоразнообразия.",
      },
    ],
  },

  {
    slug: "business-responds-to-us-reciprocal-tariff-plan",
    taxonomy: "Новости",
    dateLabel: "2 апреля 2025",
    title: "Бизнес реагирует на план США по взаимным тарифам",
    excerpt:
      "После объявления плана США по взаимным тарифам Международная торговая палата опубликовала заявление, назвав новые меры шоком для глобальной торговой системы.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2019/03/john-denton-world-chambers-twitter.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2019/03/john-denton-world-chambers-twitter.jpg?w=1024&h=512&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "Выступая от имени более 45 миллионов компаний в более чем 170 странах, Генеральный секретарь ICC Джон У. Х. Дентон AO сказал:",
      },
      {
        type: "quote",
        html:
          "То, что мы увидели сегодня, представляет собой поворотный момент в американской торговой политике, который несёт серьёзные риски ухудшения для мировой экономики.",
      },
      {
        type: "p",
        html:
          "Это, без сомнений, шок для глобальной торговой системы, но он не обязательно должен привести к системному кризису.",
      },
      {
        type: "p",
        html:
          "Компании по всей нашей сети будут срочно запрашивать разъяснения у соответствующих органов США о том, как на практике будут применяться новые тарифы на уровне стран.",
      },
      {
        type: "p",
        html:
          "Предсказуемость и определённость — фундамент для трансграничной торговли. В конечном счёте для устранения давних неэффективностей потребуются многосторонние решения.",
      },
      {
        type: "contact",
        name: "Dawn Chardonnal",
        role: "Head of Global Communications",
        phone: "(+33) 1 49 53 29 07",
        email: "dawn.chardonnal@iccwbo.org",
      },
    ],
  },

  {
    slug: "guest-blog-navigating-cross-border-disputes-in-mena",
    taxonomy: "Арбитраж и ADR",
    dateLabel: "11 февраля 2025",
    title: "Разбор трансграничных споров в регионе MENA",
    excerpt:
      "В современном взаимосвязанном мире трансграничные споры стали всё более распространёнными, особенно в регионе MENA, где пересекаются разные правовые системы и культурные нюансы.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/03/icc-dispute-resolution-services-discussion.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/03/icc-dispute-resolution-services-discussion.jpg?w=1080&h=1236&crop=1",
      alt: "",
    },
    blocks: [
      { type: "h2", text: "Преодоление правовых сложностей" },
      {
        type: "p",
        html:
          "Трансграничные споры часто затрагивают несколько юрисдикций, каждая из которых имеет свои правовые принципы. Регион MENA, с уникальным сочетанием континентального права, общего права и принципов шариата, создаёт дополнительные вызовы для арбитража.",
      },
      {
        type: "p",
        html:
          "Успешная навигация в таких спорах требует глубокого понимания местных и международных арбитражных правил, включая рамки ICC.",
      },
      { type: "h2", text: "Стратегические подходы к трансграничному арбитражу" },
      {
        type: "p",
        html:
          "Эффективное управление трансграничными спорами требует проактивного и стратегического подхода.",
      },
      {
        type: "list",
        items: [
          "<strong>Ранняя оценка рисков</strong>: анализ потенциальных рисков и ответственности",
          "<strong>Адаптированная адвокация</strong>: выстраивание стратегии с учётом особенностей юрисдикции",
          "<strong>Эффективное управление ресурсами</strong>: использование междисциплинарных команд",
          "<strong>Сотрудничество с местными консультантами</strong>: опора на локальную экспертизу",
        ],
      },
      {
        type: "h2",
        text: "Пример кейса: арбитражная поддержка крупного инфраструктурного проекта",
      },
      {
        type: "p",
        html:
          "Крупный инфраструктурный проект стоимостью более 15 млрд катарских риалов (QAR) потребовал согласования противоречивых договорных положений в рамках нескольких правовых систем.",
      },
      {
        type: "p",
        html:
          "Благодаря тщательной подготовке и стратегической адвокации спор был разрешён в пользу клиента.",
      },
      { type: "h2", text: "Заключение" },
      {
        type: "p",
        html:
          "Разбор трансграничных споров в регионе MENA требует экспертизы, стратегического видения и тонкого понимания региональных сложностей.",
      },
      {
        type: "p",
        html:
          "<em>*Дисклеймер: содержание этой статьи может не отражать официальные взгляды Международной торговой палаты.</em>",
      },
    ],
  },

  {
    slug: "calling-all-small-business-champions-of-the-circular-economy",
    taxonomy: "МСБ и предпринимательство",
    dateLabel: "30 января 2025",
    title: "Призываем всех лидеров малого бизнеса в циркулярной экономике",
    excerpt:
      "Организации, продвигающие циркулярную экономику в сообществе малого бизнеса, могут подать заявку на участие в глобально признанном конкурсе Small Business Champions Initiative 2025 до 28 марта.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/06/Office-eomployees-work-culture.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2023/06/Office-eomployees-work-culture.jpg?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "Инициатива Small Business Champions Initiative, запущенная в 2021 году, отмечает организации, которые помогают малому бизнесу участвовать и добиваться успеха в мировой торговле.",
      },
      {
        type: "p",
        html:
          "Выпуск 2025 года отметит инициативы, помогающие малым бизнесам внедрять принципы циркулярной экономики.",
      },
      { type: "h2", text: "Что мы ищем и кто может участвовать?" },
      {
        type: "list",
        items: [
          "<strong>Организации</strong>, которые ведут инициативы по информированию, обучению и наставничеству",
          "<strong>Малые бизнесы</strong> с инновационными бизнес-моделями в циркулярной экономике",
        ],
      },
      {
        type: "p",
        html:
          "Все заявки должны иметь чёткую связь с международной торговлей и включать план действий.",
      },
      { type: "h2", text: "Подайте заявку" },
      {
        type: "p",
        html:
          "Заявки следует подавать через официальную форму до 28 марта 2025 года.",
      },
      {
        type: "image",
        src:
          "https://iccwbo.org/wp-content/uploads/sites/3/2025/01/small-business-champions-2025-icc.png?w=1024",
        alt: "",
      },
    ],
  },

  {
    slug: "how-business-shaped-the-internet-governance-forum-2024",
    taxonomy: "Интернет-политика",
    dateLabel: "19 декабря 2024",
    title: "Как бизнес повлиял на Internet Governance Forum 2024",
    excerpt:
      "Internet Governance Forum — это единственный глобальный форум, где проходят открытые и инклюзивные дискуссии об управлении интернетом и цифровой политике.",
    cover: {
      listSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2024/12/2024-2-ICC-IGF-Riyadh-Photo-by-IGF.jpg?w=400&h=260&crop=1",
      heroSrc:
        "https://iccwbo.org/wp-content/uploads/sites/3/2024/12/2024-2-ICC-IGF-Riyadh-Photo-by-IGF.jpg?w=1080&h=1260&crop=1",
      alt: "",
    },
    blocks: [
      {
        type: "p",
        html:
          "Интернет развивается. И то, как мы им управляем, тоже должно развиваться. Тема этого года «Building Our Multistakeholder Digital Future» подчеркнула критическую роль сотрудничества всех стейкхолдеров.",
      },
      { type: "h2", text: "Влияет ли управление интернетом на ваш бизнес?" },
      {
        type: "p",
        html:
          "Независимо от отрасли, размера или локации, на все компании влияют правила управления интернетом и политики, разработанные для обеспечения стабильного функционирования и устойчивого роста нашего цифрового мира.",
      },
      { type: "h2", text: "Как бизнес повлиял на #IGF2024" },
      {
        type: "p",
        html:
          "Представленный Business Action to Support the Information Society (ICC BASIS) и национальными комитетами ICC, глобальный бизнес внёс вклад в решения по интернет-политике несколькими способами.",
      },
      {
        type: "p",
        html:
          "<strong>Предоставил бизнес-рекомендации по актуальным вопросам цифровой политики</strong>",
      },
      {
        type: "p",
        html:
          "ICC BASIS организовал публичные сессии и представил материалы по усилению цифрового сотрудничества, свободному потоку данных с доверием, развитию управления ИИ и защите критической инфраструктуры.",
      },
      { type: "p", html: "Сессии призвали к действиям:" },
      {
        type: "list",
        items: [
          "<strong>Согласовать</strong> существующие глобальные подходы к управлению через многостороннее сотрудничество.",
          "<strong>Создать</strong> адаптивные, совместимые политики, которые обеспечивают свободный поток данных с доверием.",
          "<strong>Принять</strong> «на будущее устойчивый», риск-ориентированный подход к управлению ИИ.",
          "<strong>Укрепить</strong> устойчивость критической инфраструктуры через согласованные усилия в кибербезопасности.",
        ],
      },
      { type: "p", html: "<strong>Сформировал мощные партнёрства</strong>" },
      {
        type: "p",
        html:
          "Участники ICC BASIS взаимодействовали с правительствами, международными организациями, гражданским обществом и техническим сообществом, чтобы обсудить Global Digital Compact и WSIS+20 в 2025 году.",
      },
      {
        type: "accordion",
        items: [
          {
            title: "Какой ваш главный вывод по итогам IGF этого года?",
            html:
              "‘’Было вдохновляюще видеть, насколько вовлечены все участники в дискуссии, которые ставят во главу угла безопасный, инклюзивный Интернет…’’ <strong>Jessica Reed, Global Policy Assistant, ICC</strong>",
          },
          {
            title: "Как полученные инсайты повлияют на работу ICC?",
            html:
              "“Инсайты, полученные в ходе ценных диалогов на IGF 2024, будут направлять нашу работу…” – <strong>Timea Suto, Global Digital Policy Lead, ICC</strong>",
          },
          {
            title: "Почему участие бизнеса в IGF критически важно?",
            html:
              "‘’Поскольку совместная модель IGF будет пересматриваться в 2025 году…’’ – <strong>Meni Anastasiadou, Digital Policy Manager, ICC</strong>",
          },
        ],
      },
      { type: "h2", text: "Готовимся к Internet Governance Forum 2025" },
      {
        type: "p",
        html:
          "IGF отметит своё 20-летие в Норвегии в июне 2025 года. ICC продолжит выступать за открытый, безопасный, стабильный и инклюзивный Интернет.",
      },
    ],
  },

{
  slug: "icc-calls-for-continued-dialogue-on-biodiversity-benefit-sharing-mechanism",
  taxonomy: "Климатические действия",
  dateLabel: "3 ноября 2024",
  title: "ICC призывает к продолжению диалога по механизму распределения выгод от биоразнообразия",
  excerpt:
    "ICC опубликовала следующее заявление по итогам Конференции сторон Организации Объединённых Наций по Конвенции о биологическом разнообразии (CBD COP16), подчеркнув приверженность бизнеса поддержке будущих усилий по созданию надёжного и работоспособного многостороннего механизма распределения выгод.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/11/GettyImages-1405452705.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/11/GettyImages-1405452705.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "ICC ценит усилия Сторон и колумбийского председательства на CBD COP16 по продвижению работы над введением в действие многостороннего механизма распределения выгод от использования цифровой информации о последовательностях, включая признание в Решении COP16 того, что необходима дальнейшая работа для уточнения нескольких его элементов.&nbsp;<br><br>Бизнес привержен поддержке целей в области биоразнообразия и конструктивно участвует в обсуждении, рассматривая многосторонний механизм как возможность увеличить объём выгод, распределяемых в поддержку биоразнообразия, за счёт более простой системы, которая обеспечивает большую правовую определённость для компаний и поддерживает исследования и инновации.",
    },
    {
      type: "quote",
      html:
        "«Как признали ряд стран, решение задаёт отправную основу для дальнейшего продвижения, однако многие важные аспекты требуют дополнительной, основанной на доказательствах, проработки, чтобы механизм имел необходимые условия и стимулы для широкого участия бизнеса. Система, которая имеет широкий охват, упрощает внесение взносов, устанавливает реалистичные уровни сборов, обеспечивает правовую определённость для исследований и инноваций и способна стимулировать большее финансирование биоразнообразия. Бизнес усилит своё участие как неотъемлемая часть решения и должен сыграть роль в дальнейшем уточнении механизма, чтобы обеспечить его успех.»",
    },
    {
      type: "p",
      html:
        "Дальнейшая работа может продолжаться по нескольким направлениям — через формальные рабочие процессы CBD, неформальные диалоги или пилотную фазу для тестирования модальностей, предусмотренных решением, и получения доказательной базы для рассмотрения на COP17.&nbsp; ICC будет работать с компаниями, странами и другими заинтересованными сторонами по всем этим направлениям, чтобы оптимизировать потенциал механизма для привлечения широкого участия бизнеса в достижении целей по биоразнообразию.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    },
  ],
},
{
  slug: "how-the-b20-is-turning-policy-into-action-for-a-sustainable-future",
  taxonomy: "Климатические действия",
  dateLabel: "29 октября 2024",
  title: "Как B20 превращает политику в действия ради устойчивого будущего",
  excerpt:
    "Под председательством Бразилии в этом году саммит Business 20 (B20) прошёл в Сан-Паулу 24 и 25 октября, объединив более 1 000 представителей бизнеса для обсуждений под темой «Инклюзивный рост ради устойчивого будущего».",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/GettyImages-582780650.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/GettyImages-582780650.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "В качестве сетевого партнёра B20 ICC поддержала Бразильскую национальную конфедерацию промышленности (CNI) в реализации темы, внеся вклад в разработку действенных политических рекомендаций, используя участие 11 членов Исполнительного совета ICC в различных рабочий группах (Task Forces), а также лидерство ICC и Всемирной федерации торговых палат в Международном деловом консультативном кокусе B20.",
    },
    {
      type: "p",
      html:
        "B20 — глобальная платформа международного бизнес-сообщества для поддержки работы процесса G20. Вот как ICC помогает B20 превращать политику в действия.",
    },

    { type: "h2", text: "Улучшение представленности женщин в рабочих группах B20" },
    {
      type: "p",
      html:
        "Будучи партнёрской организацией новой инициативы B20, направленной на увеличение представленности женщин в составе и руководстве B20, ICC обязалась поддерживать председательства B20, предлагая кандидатуры женщин, подходящих для председательства в рабочих группах B20, и поощряя женщин становиться участницами B20 через мобилизацию глобальной сети ICC в более чем 170 странах. Инициатива SheLeads B20 нацелена на достижение 50% женского представительства к 2030 году. Генеральный секретарь ICC Джон У.Х. Дентон AO, который был сопредседателем рабочей группы B20 по финансам и инфраструктуре, подписал обязательство от имени ICC вместе с представителями OECD, Business at OECD и Международной организации работодателей (IOE). Известные женщины-лидеры — почётный председатель ICC Мария Фернанда Гарса, член Совета ICC Лама Аль-Сулайман и первый вице-председатель Всемирной федерации торговых палат ICC Мари Кристин Огли — были сопредседателями рабочих групп B20 Brazil по добросовестности и комплаенсу, занятости и образованию, а также по женщинам, разнообразию и инклюзии в бизнесе соответственно. Ещё пять женщин — членов Совета ICC (Candace Johnson, Rebecca Enonchong, Marienne Coutinho, Marjorie Yang и Patricia Nzolantima) — также были участницами рабочих групп B20 в этом году.",
    },

    { type: "h2", text: "Женщины в торговле" },
    {
      type: "p",
      html:
        "ICC также является гордым сторонником наследной инициативы B20 Brazil «Women in Trade». Работая в сотрудничестве с Международным торговым центром (ITC) и Организацией экономического сотрудничества и развития (OECD), инициатива позволила G20 и B20 объединиться для обмена знаниями и лучшими практиками по инклюзивной торговой политике, направленной на увеличение участия женщин в международной торговле.",
    },

    { type: "h2", text: "Борьба с потерями и отходами пищевой продукции" },
    {
      type: "p",
      html:
        "На саммите также состоялся запуск Глобального вызова ICC-B20 против потерь и отходов пищевой продукции (Food Loss and Waste) для противодействия продовольственной небезопасности. Инициатива нацелена на выявление через глобальный конкурс проектов частного сектора, которые могут помочь решить наиболее критические вопросы, связанные с потерями и отходами пищи.",
    },
    {
      type: "p",
      html:
        "После этапа консультаций бизнес по всему миру будет приглашён представить предложения, направленные на решение пяти крупнейших проблем, связанных с потерями и отходами пищевой продукции. Проекты с наивысшим рейтингом будут представлены на Всемирном продовольственном форуме ФАО в октябре 2025 года, предоставляя возможность дополнительной публичности и взаимодействия с ключевыми заинтересованными сторонами. Являясь учредительным участником Глобального альянса против голода и бедности — одной из ключевых инициатив председательства Бразилии в G20 — ICC обязуется использовать уникальную экспертизу и сеть частного сектора для поддержки и масштабирования интегрированных решений, позволяющих устойчиво и справедливо обеспечивать мир продовольствием.",
    },

    {
      type: "p",
      html:
        "Выступая перед участниками B20 на панели о том, как наследные инициативы B20 Brazil превращают политику в действия, Генеральный секретарь ICC Джон У.Х. Дентон AO сказал:",
    },
    {
      type: "quote",
      html:
        "<strong>«Через Глобальный вызов ICC-B20 против потерь и отходов пищевой продукции мы стремимся выступать мостом между B20 и G20, обеспечивая государственно-частное сотрудничество для достижения устойчивых решений по борьбе с бедностью и голодом во всём мире.»</strong>",
    },
  ],
},
{
  slug: "trade-finance-resilience-and-low-credit-risk-persist-amid-global-challenges-confirms-icc",
  taxonomy: "Банковское дело и финансы",
  dateLabel: "29 октября 2024",
  title:
    "ICC подтверждает: устойчивость торгового финансирования и низкий кредитный риск сохраняются на фоне глобальных вызовов",
  excerpt:
    "ICC Trade Register 2024, с расширенными рыночными аналитическими материалами, подтверждает устойчивость торгового финансирования и продолжающийся низкий кредитный риск.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/icc-stats-abstract-2.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/icc-stats-abstract-2.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Международная торговая палата (ICC) совместно с партнёрами Global Credit Data (GCD) и Boston Consulting Group (BCG) выпустила отчёт 2024 Trade Register Report, вновь подтвердив устойчивость инструментов торгового финансирования и сохраняющийся низкий кредитный риск по продуктам, несмотря на продолжающиеся геополитические и экономические вызовы.&nbsp;",
    },
    {
      type: "p",
      html:
        "Отчёт 2024 года подтверждает, что торговое, цепочечное и экспортное финансирование продолжает демонстрировать низкий риск: уровни дефолтов остаются низкими во всех регионах и по всем классам активов в целом. Когда дефолты всё же происходят, они, как правило, носят идиосинкразический характер и обусловлены хорошо известными коммерческими, геополитическими или макроэкономическими факторами. По мере того как мировая торговля сталкивается с продолжающимся геополитическим и экономическим давлением, эти финансовые продукты остаются жизненно важными инструментами для снижения рисков и поддержания ликвидности, способствуя стабильности торговых потоков.&nbsp;",
    },
    {
      type: "p",
      html:
        "ICC Trade Register остаётся ведущим, авторитетным глобальным источником по кредитному риску и более широким рыночным динамикам в торговом и цепочечном финансировании. Его набор данных представляет почти четверть всех глобальных транзакций торгового финансирования. Издание 2024 года включает расширенные рыночные аналитические материалы и данные по мировой торговле и торговому финансированию. Среди новых элементов — выводы по результатам опроса практиков ICC и BCG о ключевых трендах и возможностях в торговом и цепочечном финансировании, а также комплексный набор данных с анализом кредитного риска в торговом финансировании, доступный банкам-членам или для отдельной покупки через ICC.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "В этом году ICC и GCD продемонстрировали ценность высококачественных, репрезентативных данных в формировании регулирования торгового финансирования благодаря своему вкладу в формирующееся регулирование по Basel III — в части капитального подхода к торговому финансированию. Кришан Рамадурай, уходящий председатель проекта ICC Trade Register, призывает больше банков участвовать в проекте и отмечает, что больше данных лишь укрепит тезис о том, что торговое финансирование — это класс активов с низким уровнем дефолтов.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "ICC Trade Register продолжает выходить за рамки кредитного риска, предоставляя детальный анализ рыночных трендов и конкурентной динамики на рынке торгового и цепочечного финансирования.&nbsp;&nbsp;",
    },

    { type: "p", html: "Рави Хансапал, партнёр BCG, сказал:&nbsp;" },
    {
      type: "quote",
      html:
        "<strong>«Несмотря на продолжающиеся встречные ветры, мы видим, что рынок торгового и цепочечного финансирования продолжает быстро эволюционировать. Банки отмечают, что клиенты сейчас как никогда раньше придают приоритет качеству сервиса и цифровым возможностям, что стимулирует скачкообразное увеличение инвестиций банков в технологии для ускорения бесшовной торговли.»</strong>&nbsp;",
    },

    {
      type: "p",
      html:
        "Мэрилин Блаттнер-Хойл, глобальный руководитель по торговому финансированию и решениям оборотного капитала в Swiss Reinsurance Company, сказала:&nbsp;",
    },
    {
      type: "quote",
      html:
        "<strong>«ICC Trade Register и его глубокие данные за многие циклы — пожалуй, самая критически важная публикация в отрасли торговли. Роль Register в распространении количественной и качественной статистики подчёркивает силу торговли, а также устойчивость торговых кредитных рисков. Это помогает нам увереннее страховать больше объёма торговли вместе с нашими банковскими клиентами, делая торговлю и мир более устойчивыми вместе. Мы используем Register в наших актуарных оценках, а также во внутренней и внешней адвокации. Мы гордимся тем, что стали первым страховым спонсором публикации, подтверждая важную роль страхования в глобальной торговой экосистеме.»</strong>&nbsp;",
    },

    {
      type: "p",
      html:
        "Кристиан Хаусхерр, продукт-менеджер по SCF в Deutsche Bank и член Руководящего комитета ICC Trade Register, сказал:&nbsp;",
    },
    {
      type: "quote",
      html:
        "<strong>«На тринадцатый год после основания ICC Trade Register доказывает свою актуальность и значимость для сообщества торгового финансирования. С тех пор подход к данным, а также охват Trade Register были существенно расширены командой, которая ежегодно управляет процессом подготовки публикации. На сегодняшний день Trade Register предлагает уникальные инсайты не только о рисках торгового финансирования, но и предоставляет читателям ценные макроэкономические выводы.»</strong>&nbsp;",
    },

    {
      type: "p",
      html:
        "Политический менеджер ICC Томаш Кубяк благодарит банки-члены за их постоянный вклад.<strong> </strong>",
    },
    {
      type: "quote",
      html:
        "<strong>«ICC очень признательна за все усилия, которые банки-члены вновь прикладывают ради улучшенной версии ICC Trade Register. Проект этого года даёт полное представление о значимых трендах в глобальном торговом финансировании, а также содержит полный объём данных, собранных у наших членов, которые теперь доступны по запросу»,</strong> &nbsp;<br><cite>сказал он.</cite>",
    },

    {
      type: "contact",
      title:
        "Для получения дополнительной информации о ICC Trade Register 2024, включая вопросы об участии и стоимости отчёта, пожалуйста, свяжитесь:",
      contacts: [
        {
          name: "Tomasch Kubiak",
          job: "Policy Manager | Global Policy Team | Banking Commission",
          email: "tomasch.kubiak@iccwbo.org",
        },
        {
          name: "Andrew WILSON",
          job: "Deputy Secretary General – Policy",
          email: "andrew.wilson@iccwbo.org",
        },
      ],
    },

    {
      type: "p",
      html:
        '<a href="https://iccwbo.org/publication/icc-trade-register-report/" target="_blank" rel="noreferrer noopener">Прочитать или приобрести полный отчёт ICC Trade Register</a>.&nbsp;',
    },
  ],
},
{
  slug: "inflation-trade-uncertainty-and-labour-gaps-cloud-business-outlook-says-new-global-survey-of-chambers",
  taxonomy: "Услуги палат",
  dateLabel: "16 октября 2024",
  title:
    "Инфляция, торговая неопределённость и дефицит рабочей силы ухудшают бизнес-прогноз, говорится в новом глобальном опросе торговых палат",
  excerpt:
    "Инфляция, нехватка квалифицированных кадров и торговые неопределённости давят на перспективы мирового бизнеса — согласно новому опросу местных бизнес-организаций в 96 странах, проведённому Международной торговой палатой (ICC).",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/icc-global-market-trade-finance.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/10/icc-global-market-trade-finance.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Результаты глобального экономического опроса отражают взгляды бизнеса на ключевые экономические и устойчивые вопросы в экономиках, которые в совокупности формируют 90% мирового ВВП.&nbsp;&nbsp;&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Комментируя запуск результатов опроса в Стамбуле, Генеральный секретарь ICC Джон У.Х. Дентон AO сказал:&nbsp;<strong> </strong>",
    },
    {
      type: "quote",
      html:
        "«Как голос реальной экономики во всём мире, ICC использовала свой уникальный институциональный охват, чтобы представить комплексную глобальную картину реалий ведения бизнеса в сегодняшней всё более сложной среде. Мы надеемся, что эти данные в реальном времени помогут сформировать стратегический ответ правительств на ключевые вызовы, с которыми сталкиваются ММСП.»&nbsp;&nbsp;",
    },

    { type: "spacer", height: 10 },

    { type: "h3", text: "Глобальная бизнес-среда&nbsp;&nbsp;" },
    {
      type: "p",
      html:
        "Рост цен и затрат на труд был назван значительным вызовом в большинстве опрошенных стран: более 80% респондентов выразили обеспокоенность тем, что ценовое давление сохранится и в 2025 году — ставя под сомнение недавние заявления некоторых известных экономистов о том, что инфляция «больше не проблема».&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Инфляция привела к существенно более высоким затратам на персонал для бизнеса в 44 странах — тенденция, которая в некоторых регионах усугубляется нехваткой навыков на местном рынке труда, прежде всего в Северной Америке и Европе.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Экономическая среда и жёсткие финансовые условия затруднили доступ к финансированию: результаты показывают, что высокие процентные ставки ограничивают доступ к кредиту, особенно в странах Африки к югу от Сахары (80%), Латинской Америке и Карибском бассейне (63%), а также Южной Азии (60%).&nbsp;",
    },
    {
      type: "p",
      html:
        "Торговая неопределённость была названа проблемой 50% респондентов из торговых палат — при этом самые высокие опасения отмечены в Восточной Азии и Тихоокеанском регионе (69%), на Ближнем Востоке и в Северной Африке (60%) и в Латинской Америке и Карибском бассейне (50%).&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Несмотря на эти вызовы, респонденты в более чем 50% охваченных опросом стран выразили осторожный оптимизм относительно перспектив бизнеса в своих экономиках — что говорит о значительной устойчивости перед лицом экономических и операционных рисков.&nbsp;&nbsp;",
    },
    { type: "p", html: "Г-н Дентон добавил:" },
    {
      type: "quote",
      html:
        "«Хотя в последние месяцы заголовочные показатели инфляции в целом снизились, скачок цен, наблюдавшийся с 2022 года, очевидно, продолжает оказывать устойчивое воздействие на частный сектор во многих странах. Политикам необходимо учитывать разрыв между макроэкономическими данными и повседневным опытом местного бизнеса.»&nbsp;",
    },

    { type: "spacer", height: 10 },

    { type: "h3", text: "Перспективы климатических действий&nbsp;&nbsp;" },
    {
      type: "p",
      html:
        "За месяц до климатического саммита ООН COP29 опрос также изучил опыт малых и средних предприятий (SMEs) в переходе к климатически дружественным бизнес-моделям.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "В развивающихся экономиках торговые палаты указали на трудности, с которыми сталкиваются SMEs при доступе к чистым источникам энергии — как из национальных сетей, так и из децентрализованной генерации.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "В развитых экономиках SMEs сдерживаются воспринимаемым отсутствием доступа к передовым «зелёным» технологиям и ограниченной внутренней компетенцией для внедрения программ по снижению выбросов.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "И в развитых, и в развивающихся экономиках доступ к экономически эффективному финансированию для инвестиций в декарбонизацию был назван серьёзным вызовом — что указывает на необходимость расширенной государственной поддержки, чтобы SMEs могли внедрять «зелёные» технологии и модернизировать существующие объекты.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Рифат Хисарджиклыоглу, председатель Всемирной федерации торговых палат ICC, добавил:",
    },
    {
      type: "quote",
      html:
        "«Этот опрос подчёркивает ключевую роль торговых палат по всему миру как частных чемпионов. Они глубоко чувствуют «на земле» реалии ведения бизнеса, сохраняя при этом глобальную перспективу и оставаясь связанными через нашу Всемирную федерацию торговых палат ICC.»&nbsp;&nbsp;",
    },

    {
      type: "button",
      text: "Прочитать больше и скачать полный отчёт.",
      href:
        "https://iccwbo.org/news-publications/policies-reports/chamber-pulse-global-markets-local-landscapes/",
    },
  ],
},
{
  slug: "icc-institute-world-business-law-prize-open-for-applications",
  taxonomy: "Премия Института",
  dateLabel: "11 сентября 2024",
  title: "Премия ICC Institute World Business Law Prize открыта для заявок",
  excerpt:
    "Институт международного коммерческого права ICC (ICC Institute of World Business Law) объявил о запуске 10-го издания премии ICC Institute Prize. Награда отмечает выдающиеся юридические исследования в области международного коммерческого права и арбитража.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/09/institute-prize-business-law.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/09/institute-prize-business-law.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Основанная в 2007 году, премия Института поощряет сфокусированные исследования по правовым вопросам, влияющим на международный бизнес. Способствуя пониманию и развитию международного коммерческого права во всём мире, награда признаёт выдающееся качество юридических работ. Помимо признания, лауреаты получают € 10 000 призовых.&nbsp;",
    },
    {
      type: "p",
      html:
        'Премия ICC Institute Prize открыта для всех в возрасте 40 лет или младше, кто подаёт докторскую диссертацию или большой эссе-труд (минимум 150 страниц), написанный на французском или английском языках по международному коммерческому праву, включая арбитраж. Крайний срок подачи работ на 10-е издание — 7 апреля 2025 года. Специальная церемония награждения состоится в Париже в конце 2025 года по случаю ежегодной конференции Института международного коммерческого права ICC. <a href="https://iccwbo.org/dispute-resolution/professional-development/icc-institute-of-world-business-law/institute-of-world-business-law-prize/" target="_blank" rel="noreferrer noopener">Подробнее и правила — здесь.</a>&nbsp;',
    },
    {
      type: "p",
      html:
        "Победитель прошлого года, Сабрина Пирсон-Венгер, получила премию за диссертацию «Добросовестность в международном коммерческом арбитраже: её применение арбитражными трибуналами к договору сторон и арбитражному соглашению».&nbsp;",
    },
    {
      type: "p",
      html:
        '<a href="https://iccwbo.org/news-publications/news/icc-institute-prize-winner-announced/">В издании премии Института 2023 года</a> было 27 заявок из девяти стран — это второй по величине показатель за всю историю премии. Все заявки были тщательно рассмотрены международным жюри, состоящим из девяти членов Совета Института ICC. Учитывая значительное число поданных работ, 18 членов Института ICC помогали жюри в чтении и оценке диссертаций.&nbsp;',
    },
    {
      type: "p",
      html:
        "В издании 2025 года жюри возглавит член Совета Института ICC Уинни Ма, вместе с членами Совета Маурисио Алмейда Прадо, Толга Айоглу, Маттиасом Шерером, Джунги Кимом, Кристиной Мартинетти, Стейси Стронг, Хабибату Туре и Галиной Жуковой. Их разнообразная экспертиза обеспечит строгий процесс оценки, продолжая традицию, заложенную предыдущими жюри.&nbsp;",
    },
    {
      type: "p",
      html:
        'Ежегодная конференция Института международного коммерческого права ICC в этом году состоится 13 ноября 2024 года и будет посвящена темам <a href="https://events2go.iccwbo.org/event/icc-institute-annual-conference" target="_blank" rel="noreferrer noopener">Res Judicata, Claim Preclusion, Issue Preclusion и Claim Splitting</a>.&nbsp;',
    },
  ],
},
{
  slug: "no-alternative-to-multilateralism-in-trade-says-icc-sg-at-g7",
  taxonomy: "Торговля",
  dateLabel: "16 июля 2024",
  title: "Генеральный секретарь ICC на G7: «В торговле нет альтернативы многосторонности»",
  excerpt:
    "Генеральный секретарь Международной торговой палаты призвал крупнейшие развитые экономики мира предпринять значимые шаги по реформе Всемирной торговой организации (ВТО) накануне встречи министров торговли G7 в Реджо-Калабрия, Италия.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/03/429889488_787180743449221_5312163257327952846_n.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/03/429889488_787180743449221_5312163257327952846_n.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "В ключевой речи на специальном мероприятии, организованном итальянским председательством G7 в преддверии министерской встречи, Джон У.Х. Дентон подчеркнул настоятельную необходимость для правительств укреплять многостороннюю торговую систему на фоне опасений роста протекционизма и нарастающих торговых трений.",
    },
    {
      type: "quote",
      html:
        "«Мы призываем государства-члены руководствоваться прагматизмом, а не политикой, и стремиться к комплексной реформе ВТО, чтобы она продолжала служить нуждам бизнеса — и сообществ, которым он служит.»&nbsp;",
      cite: "Генеральный секретарь ICC Джон У.Х. Дентон AO",
    },
    {
      type: "p",
      html:
        "Г-н Дентон вновь выразил обеспокоенность ICC постепенной эрозией многосторонней торговой системы в последние годы, указав на то, что возможный крах системы ВТО вызовет серьёзный экономический шок.",
    },
    {
      type: "p",
      html:
        "«Давайте говорить прямо: крах многосторонней торговой системы, основанной на правилах, приведёт к большей неопределённости и экономическим потерям для всех развивающихся стран — включая снижение глобальной торговли товарами на 33%, а также постоянную потерю ВВП более чем на 5%», — сказал г-н Дентон, ссылаясь на выводы исследования ICC и Oxford Economics о потенциальных долгосрочных структурных последствиях распада ВТО для развивающихся экономик <a href=\"https://iccwbo.org/news-publications/policies-reports/study-shows-wto-collapse-could-slash-exports-of-developing-countries-by-33-percent/\">(исследование)</a>.",
    },
    {
      type: "p",
      html:
        "Исследование показало, что наименее развитые экономики столкнутся со снижением экспорта на 43% без жизненно важной «подушки безопасности» в виде многосторонних торговых правил. Последствия распада ВТО будут постепенно усиливаться, при этом полный эффект достигнет пика к 2030 году и останется постоянным.",
    },
    {
      type: "quote",
      html:
        "«Нам нужны действия от правительств, ВТО и лидерства бизнеса; мы хотим, чтобы мост между развивающимися и продвинутыми экономиками сохранялся через ВТО», — добавил г-н Дентон.",
    },
    {
      type: "p",
      html:
        "Конференция отраслевых стейкхолдеров является официальным сайд-ивентом министерской встречи G7 по торговле, которая состоится 17 июля, и организована совместно с B7 — официальной платформой международного бизнес-сообщества для поддержки работы G7.",
    },
    {
      type: "p",
      html:
        "На полях конференции г-н Дентон также принял участие в серии двусторонних встреч с министрами и бизнес-лидерами из стран G7, а также с руководителями нескольких международных организаций.",
    },
    {
      type: "p",
      html:
        "ICC также является сетевым партнёром B20 для B20 Brazil 2024 — бизнес-платформы для поддержки процесса G20.",
    },
  ],
},
{
  slug:
    "no-room-for-complacency-maritime-piracy-incidents-fall-but-crew-safety-remains-at-risk",
  taxonomy: "Торговля",
  dateLabel: "11 июля 2024",
  title:
    "Нет места самоуспокоенности: число инцидентов морского пиратства снижается, но безопасность экипажей остаётся под угрозой",
  excerpt:
    "Международное морское бюро (IMB) ICC призывает к постоянной бдительности для защиты моряков на фоне роста насилия, несмотря на общее снижение числа инцидентов, зафиксированных в промежуточном отчёте за первое полугодие 2024 года, опубликованном сегодня.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/07/GettyImages-1201905537.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/07/GettyImages-1201905537.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "В первом полугодии 2024 года зафиксировано 60 инцидентов пиратства и вооружённых нападений на суда — меньше, чем 65 инцидентов за тот же период 2023 года.&nbsp;",
    },
    {
      type: "quote",
      html:
        "«Хотя нас обнадёживает снижение общего числа зарегистрированных актов пиратства, вызывающий тревогу рост инцидентов насильственного характера подчёркивает необходимость постоянной бдительности со стороны международного сообщества для обеспечения безопасности всех моряков — особенно в период повышенной неопределённости для морских перевозок.»&nbsp;",
      cite: "Генеральный секретарь ICC Джон У.Х. Дентон AO",
    },
    {
      type: "p",
      html:
        "Из 60 зарегистрированных инцидентов 46 судов были взяты на абордаж, восемь сообщили о попытках атаки, четыре были захвачены, и по двум был открыт огонь.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Насилие в отношении экипажей сохраняется: 85 человек были взяты в заложники по сравнению с 36 за тот же период прошлого года, 11 — похищены, двоим угрожали. О наличии огнестрельного оружия и ножей сообщалось в 34 из 60 инцидентов — тревожный рост по сравнению с прошлым годом.&nbsp;&nbsp;",
    },
    {
      type: "quote",
      html:
        "«Хотя снижение числа зарегистрированных инцидентов — позитивный сигнал, устойчивое и постоянное региональное морское сотрудничество остаётся критически важным для защиты моряков, глобального судоходства и торговли. Нет места самоуспокоенности.»",
      cite: "Директор IMB Майкл Хоулетт.",
    },

    { type: "h3", text: "Призывы к осторожности в водах у побережья Сомали&nbsp;" },
    {
      type: "p",
      html:
        "Несмотря на снижение глобального числа зарегистрированных инцидентов, сомалийское пиратство всё ещё представляет угрозу: в первом полугодии 2024 года зарегистрировано восемь инцидентов, включая три захвата судов.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Недавние случаи демонстрируют сохраняющиеся возможности и потенциал сомалийских пиратов атаковать суда на расстоянии до 1 000 морских миль (nm) от сомалийского побережья.&nbsp;",
    },
    {
      type: "p",
      html:
        "«Мы продолжаем призывать к осторожности в связи с инцидентами сомалийского пиратства и обращаемся ко всем судовладельцам и капитанам с просьбой усиливать защиту судов и следовать всем рекомендуемым руководящим принципам в актуальной версии Best Management Practices при транзите через сомалийские воды», — сказал г-н Хоулетт.&nbsp;&nbsp;",
    },

    { type: "h3", text: "Обеспокоенность за экипажи в Гвинейском заливе&nbsp;" },
    {
      type: "p",
      html:
        "В Гвинейском заливе число инцидентов снизилось с 14 до 10, однако угрозы безопасности и благополучию экипажей остаются поводом для серьёзной обеспокоенности.",
    },
    {
      type: "p",
      html:
        "На регион приходится 11 похищенных членов экипажей по всему миру в первом полугодии 2024 года — в двух отдельных инцидентах — и 21 человек, взятый в заложники в одном инциденте.",
    },
    {
      type: "p",
      html:
        "IMB вновь подчёркивает необходимость сохранять устойчивое и сильное региональное и международное военно-морское присутствие для реагирования на такие инциденты и защиты жизни на море.",
    },

    { type: "h3", text: "Низкий уровень сообщений о случаях в Сингапурском проливе " },
    {
      type: "p",
      html:
        "Отмечается заметное снижение числа зарегистрированных инцидентов в Сингапурском проливе: 13 в первом полугодии 2024 года по сравнению с 20 за тот же период прошлого года. Однако нацеливание и абордаж крупных судов, проходящих через эти воды, по-прежнему вызывает тревогу.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Хотя такие преступления считаются низкоуровневыми оппортунистическими, в шести отдельных инцидентах 10 членов экипажа были взяты в заложники; о наличии оружия и ножей сообщалось в 10 инцидентах.&nbsp;",
    },
    {
      type: "p",
      html:
        "Несмотря на снижение числа зарегистрированных инцидентов, IMB известно о случаях, о которых не сообщалось.&nbsp;&nbsp;",
    },

    {
      type: "h3",
      text: "Рост инцидентов в индонезийском архипелаге и Бангладеш",
    },
    {
      type: "p",
      html:
        "IMB зарегистрировало 12 инцидентов в индонезийском архипелаге — это максимум с первого полугодия 2020 года, когда было зарегистрировано 15 инцидентов.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Сообщалось, что в этих инцидентах двое членов экипажа были взяты в заложники, а одному угрожали. Ножи были отмечены в шести инцидентах, оружие — в одном. В этом году шесть инцидентов произошли на якорной стоянке Думай по сравнению с одним в первом полугодии 2023 года.&nbsp;",
    },
    {
      type: "p",
      html:
        "Низкоуровневые инциденты увеличились в Бангладеш: с одного в первом полугодии 2023 года до десяти в 2024 году. Это наибольшее число зарегистрированных инцидентов за первое полугодие года с 2015 года. Все суда находились на якорной стоянке; девять инцидентов зарегистрированы в Чаттограме.&nbsp;",
    },
    {
      type: "p",
      html:
        'Скачать копию отчёта Piracy and Armed Robbery Against Ships за январь—июнь 2024 года можно <a href="https://www.icc-ccs.org/piracy-reporting-centre/request-piracy-report">здесь</a>.',
    },

    { type: "h3", text: "Центр сообщения о пиратстве IMB" },
    {
      type: "p",
      html:
        "С момента основания в 1991 году Центр сообщения о пиратстве IMB служит критически важным круглосуточным пунктом контакта для сообщения о пиратских преступлениях и оказания поддержки судам под угрозой. Быстрая реакция и координация с реагирующими агентствами, а также рассылка предупреждающих трансляций и email-оповещений судам помогли укрепить безопасность на морских путях. Собираемые Центром данные также дают ключевые инсайты о природе и состоянии современного пиратства.&nbsp;",
    },
    {
      type: "p",
      html:
        "IMB призывает всех капитанов и судовладельцев сообщать обо всех фактических, попытках и подозреваемых инцидентах пиратства и вооружённых нападений по всему миру в Центр сообщения о пиратстве как о важнейшем первом шаге для обеспечения того, чтобы власти выделяли достаточные ресурсы на борьбу с морским пиратством.&nbsp;&nbsp;",
    },
  ],
},
{
  slug: "inaugural-regional-summit-gets-underway-in-bogota",
  taxonomy: "Всемирная федерация торговых палат",
  dateLabel: "8 мая 2024",
  title: "В Боготе стартует первый региональный саммит",
  excerpt:
    "Всемирная федерация торговых палат ICC (WCF) и Торговая палата Боготы (CCB) проводят Саммит Америк 8–9 мая 2024 года в Боготе.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/05/icc-bogota-view.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/05/icc-bogota-view.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        'Этот первый <a href="https://iccwbo.org/news-publications/news/regional-summits-to-intensify-chamber-impact/" target="_blank" rel="noreferrer noopener">региональный саммит WCF</a> проанализирует рыночные тренды и международные бизнес-возможности в ключевых секторах для ММСП через академическое и нетворкинговое пространство, которое будет способствовать торговле и росту продаж для предпринимателей в Боготе и регионе.&nbsp;',
    },
    {
      type: "p",
      html:
        "Под темой «Бизнес без границ: ММСП выходят на глобальный уровень» саммит соберёт представителей более чем 30 стран, 35 торговых палат и 500 ММСП, а также более 400 торговых компаний в течение двух дней обучения и делового общения.&nbsp;&nbsp;",
    },
    { type: "p", html: "Председатель Всемирной федерации торговых палат ICC Рифат Хисарджиклыоглу сказал:&nbsp;" },
    {
      type: "quote",
      html:
        "«Мы рады запустить серию региональных саммитов WCF в Колумбии, закладывая основу для глобальной инициативы, которая объединяет палаты со всего мира для развития сотрудничества, направленного на повышение бизнес-благополучия. Впереди мы с нетерпением ждём возможности приветствовать многочисленные палаты со всего мира на нашем втором издании в октябре, которое пройдёт при поддержке Союза палат и товарных бирж Турции в Стамбуле.»&nbsp;",
      strong: true,
    },
    {
      type: "p",
      html:
        "Повестка мероприятия будет охватывать темы глобального значения — от уроков лидерства для предпринимателей на панельных дискуссиях, ключевых выступлениях и динамических интервью, анализирующих уроки от мировых лидеров, — до лучших практик, вызовов региональных цепочек добавленной стоимости и расширения рынков через расширение возможностей, межпалатные отношения и культурные связи.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Овидио Кларос Поланко, президент Торговой палаты Боготы, сказал:<strong>&nbsp;</strong>&nbsp;",
    },
    {
      type: "quote",
      html:
        "«От имени Торговой палаты Боготы мы хотим продвигать и делать возможными рабочие пространства, которые позволяют развитию бизнеса ММСП, чтобы укреплять народную экономику. Этим саммитом мы хотим внести вклад в расширение рынков и их бизнеса, продвигая связанную и процветающую деловую среду.»&nbsp;",
      strong: true,
    },
    {
      type: "p",
      html:
        "Стремясь рассматривать глобальные вызовы и возможности через региональную призму, саммит также изучит, как цифровые инструменты — от оптимизации технологий до искусственного интеллекта — трансформируют бизнес. Он также рассмотрит, как геополитика и глобальные цепочки поставок в Латинской Америке важны в взаимосвязанном мире для поддержки ММСП, основы экономики.&nbsp;",
    },
    { type: "p", html: "Джон У.Х. Дентон AO, Генеральный секретарь Международной торговой палаты, сказал:&nbsp;&nbsp;" },
    {
      type: "quote",
      html:
        "«Повышая способность бизнеса к инновациям, масштабированию и созданию возможностей для всех и везде, наш первый региональный саммит WCF станет катализатором для палат и бизнеса в Латинской Америке в укреплении торговли и международного сотрудничества. В свою очередь, вопросы реальной экономики и барьеры, обсуждаемые на саммите, будут информировать нашу работу на глобальном уровне как самой инклюзивной бизнес-сети в мире.»&nbsp;",
      strong: true,
    },
    {
      type: "p",
      html:
        "Помимо г-на Дентона, среди ключевых спикеров Саммита Америк — Мария Фернанда Гарса, председатель Международной торговой палаты; Токи Мабогунже, вице-президент по Африке Всемирной федерации торговых палат ICC; Ричард Нгатиа, президент Восточноафриканской торговой палаты промышленности и сельского хозяйства; Хассан Аль Хашими, вице-президент по международным отношениям Торговой палаты Дубая; Марсело Элизондо, директор Аргентинской торговой палаты; Мария Тереза Бустаманте, президент Бразильской торговой палаты и Федерации промышленности; Шэннон К. О’Нил, вице-президент Совета по международным отношениям; и Андрес Морено, основатель, председатель совета директоров и CEO Open English.&nbsp;",
    },
    {
      type: "p",
      html:
        '<a href="https://iccwbo.org/world-chambers-federation/chamber-services/icc-world-chambers-federation-regional-summits/" target="_blank" rel="noreferrer noopener">Узнать больше о региональных саммитах WCF</a>&nbsp;',
    },
  ],
},
{
  slug: "applications-now-open-for-startup-awards",
  taxonomy: "ММСП и предпринимательство",
  dateLabel: "7 мая 2024",
  title: "Открыт приём заявок на премии для стартапов",
  excerpt:
    "Заявки открыты до 31 августа на второе издание церемонии награждения Startup Ecosystem Stars (SES), которая состоится 4 декабря 2024 года в Париже.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/05/pexels-dana-tentis-118658-370799.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/05/pexels-dana-tentis-118658-370799.jpg?w=1080&h=1200&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        'Организовано совместно ICC и <a href="https://mindthebridge.com/" target="_blank" rel="noreferrer noopener">Mind the Bridge</a> (MTB) в сотрудничестве с <a href="https://www.oecd.org/" target="_blank" rel="noreferrer noopener">OECD</a> и <a href="https://commission.europa.eu/index_it" target="_blank" rel="noreferrer noopener">Европейской комиссией</a>, при поддержке <a href="https://www.microsoft.com/it-it" target="_blank" rel="noreferrer noopener">Microsoft</a>, премии SES отмечают выдающиеся организации, развивающие инновации в своих экосистемах, а также демонстрируют истории успеха, продвигают сотрудничество и стимулируют возможности роста инновационных экосистем.&nbsp;',
    },
    {
      type: "quote",
      html:
        "«<em>Инновационные экосистемы играют решающую и жизненно важную роль в поддержке предпринимательства и достижении глобальных целей. Мы в ICC считаем, что демонстрация лидерства в этих экосистемах не только помогает бизнесу процветать, но и создаёт больше возможностей, основанных на общей цели, ради более светлого будущего для всех.</em>»",
      cite:
        "Candace Johnson, член Исполнительного совета ICC, вице-председатель Политического комитета ICC и председатель жюри премии.",
    },
    {
      type: "p",
      html:
        "В прошлом году бывший комиссар ЕС Мария Габриэль получила специальное признание «Человек года» за значительный вклад в развитие инновационных экосистем в Европе и за её пределами. Кроме того, 15 регионов и городов в четырёх категориях из 10 стран и пяти континентов были признаны «Startup Ecosystem Stars».&nbsp;",
    },
    {
      type: "quote",
      html:
        "«<em>Премии SES основаны на десятилетнем исследовании и опыте отслеживания и бенчмаркинга инновационных экосистем по всему миру. Эта инициатива использует модель MiTB ‘Innovation Ecosystem Life Cycle Model’ для международных сравнений, оценки траекторий роста и выявления факторов, стоящих за разными темпами роста,</em>»",
      cite:
        "<em>сказали <strong>Альберто Онетти и Марко Маринуччи</strong>, соответственно председатель и CEO Mind the Bridge.&nbsp;&nbsp;</em>",
    },
    {
      type: "p",
      html:
        "Премии SES следуют процессу открытого приёма заявок и нацелены на программы и инициативы, способные ускорить развитие инновационных экосистем. Кандидатами могут быть государственные или частные организации либо агентства, представляющие города, регионы, страны или наднациональные структуры, которые оказывают прямое влияние на свои инновационные экосистемы.&nbsp;",
    },
    {
      type: "p",
      html:
        "Для соответствия требованиям организации и агентства должны реализовывать выдающиеся программы в одной из следующих пяти категорий: Best-in-class Startup Programs, Outstanding Investment Boost, Visionary Public Procurement, Top Talent and Research и Exceptional Industry Support.&nbsp;",
    },
    { type: "p", html: "Инициативы оцениваются по таким критериям, как новизна программы, влияние и эффективность.&nbsp;" },
    { type: "p", html: "Заявки оценивает выдающееся жюри под руководством Candace Johnson, серийного предпринимателя и члена Исполнительного совета ICC.&nbsp;" },
    { type: "p", html: "Победители будут приглашены на официальную церемонию награждения в глобальной штаб-квартире ICC в Париже в декабре.&nbsp;&nbsp;" },
    {
      type: "p",
      html:
        'Подать <a href="https://mindthebridge.typeform.com/ses-2024">заявку</a>.',
    },
  ],
},
{
  slug: "saudi-arabia-and-the-philippines-to-launch-ata-operations-in-2024",
  taxonomy: "Карнет АТА",
  dateLabel: "22 апреля 2024",
  title: "Саудовская Аравия и Филиппины запустят операции ATA в 2024 году",
  excerpt:
    "Международная торговая палата (ICC) приветствует Королевство Саудовская Аравия и Республику Филиппины в составе Международной гарантийной цепи карнета АТА (ATA Chain). Карнет АТА — международный таможенный документ, действующий с 1963 года, позволяющий временный ввоз товаров без уплаты пошлин и налогов на срок до одного года.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2021/09/icc-world-trade-business-transport.jpg?w=380&h=440&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2021/09/icc-world-trade-business-transport.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Внедрение карнетов АТА будет действовать с 1 июня 2024 года для Королевства Саудовская Аравия и с 15 июля 2024 года для Республики Филиппины, что делает процедуру карнета АТА операционной в 81 стране/таможенной территории.&nbsp;",
    },
    {
      type: "p",
      html:
        "Федерация торговых палат Саудовской Аравии и Торгово-промышленная палата Филиппин в качестве национальных гарантирующих и выдающих ассоциаций были одобрены на заседании Генерального совета Всемирной федерации торговых палат ICC (WCF) 21 ноября 2023 года.&nbsp;&nbsp;&nbsp;",
    },
    { type: "p", html: "Джулиан Кассум, директор ICC WCF, сказал:" },
    {
      type: "quote",
      html:
        "<em>«</em>Опираясь на несколько лет подготовительной работы с государственным и частным сектором в обеих странах, мы рады создать ATA Chain в Саудовской Аравии и на Филиппинах в 2024 году. Это значительное достижение для бизнес-сообщества. Мы убеждены, что бизнесу и торговцам будет гораздо проще вести дела с саудовскими и филиппинскими партнёрами благодаря карнетам АТА, повышая международную конкурентоспособность рынков и местной продукции обеих стран.»&nbsp;&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "С 1 июня 2024 года саудовская таможня начнёт принимать карнеты АТА для товаров для демонстрации или использования на выставках, ярмарках, встречах или аналогичных мероприятиях (Приложение B1 Стамбульской конвенции).&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "Область применения процедуры карнета АТА на Филиппинах, начиная с 15 июля 2024 года, будет включать выставки, профессиональное оборудование, коммерческие образцы, товары в связи с производственной операцией, товары для образовательных, научных или культурных целей, личные вещи путешественников и товары для спортивных целей, товары для гуманитарных целей и даже животных.&nbsp;&nbsp;",
    },
    { type: "p", html: "Хенк Вит, председатель World ATA Carnet Council (WATAC), сказал:" },
    {
      type: "quote",
      html:
        "«Присоединение Федерации торговых палат Саудовской Аравии к ATA Chain даёт существенные преимущества пользователям ATA, особенно выставочной и событийной индустрии. Мы убеждены, что карнет АТА сыграет ключевую роль в международном развитии страны, особенно с учётом того, что в 2030 году там пройдёт World Expo в Эр-Рияде.»&nbsp;&nbsp;",
    },
    { type: "p", html: "Что касается Филиппин, г-н Вит приветствовал широкий охват применения и сказал, что" },
    {
      type: "quote",
      html:
        "«такая гибкость наверняка будет высоко оценена международным сообществом и значительно поможет стране привлекать иностранных инвесторов и посетителей.»&nbsp;",
    },
    {
      type: "p",
      html:
        "Карнеты АТА, также известные как «паспорт для товаров», — международно признанные таможенные документы, которые позволяют временный импорт товаров без уплаты пошлин и налогов на срок до одного года.&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "ATA Chain — гарантийный механизм, администрируемый Всемирной федерацией торговых палат ICC (WCF). Карнеты АТА выдаются на национальном уровне национальными гарантирующими ассоциациями (NGAs).&nbsp;&nbsp;",
    },
    {
      type: "p",
      html:
        "До Олимпийских и Паралимпийских игр 2024 года в Париже остаётся менее 100 дней, и тысячи спортсменов, представителей медиа и поставщиков готовятся к поездке во Францию этим летом. Карнет АТА — жизненно важный инструмент для перемещения их вещательного, спортивного и другого профессионального оборудования через границы — без пошлин и налогов — для использования на Играх.&nbsp;",
    },
    {
      type: "figure",
      html:
        '<figure class="wp-block-image aligncenter size-large is-resized"><a href="https://www.linkedin.com/posts/international-chamber-of-commerce_paris2024-atacarnet-paris2024-activity-7186340157694910464-5K9s?utm_source=share&amp;utm_medium=member_desktop"><img fetchpriority="high" decoding="async" src="https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png?w=454" alt="" class="wp-image-519762" width="227" height="387" srcset="https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png 454w, https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png?resize=176,300 176w, https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png?resize=110,187 110w, https://iccwbo.org/wp-content/uploads/sites/3/2024/04/icc-linkedin-post-ata-carnet.png?resize=220,375 220w" sizes="(max-width: 227px) 100vw, 227px"></a></figure>',
    },
    {
      type: "button",
      text: "Подробнее о карнете АТА",
      href: "https://iccwbo.org/business-solutions/ata-carnet/",
    },
  ],
},
{
  slug: "new-icc-hearing-centre-unveiled",
  taxonomy: "Услуги по разрешению споров",
  dateLabel: "18 марта 2024",
  title: "Представлен новый Hearing Centre ICC",
  excerpt:
    "ICC объявила детали открытия Hearing Centre ICC в Париже, включая расположение, концепцию и ожидаемую дату открытия.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/03/icc-new-hearing-center-news.png?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/03/icc-new-hearing-center-news.png?w=1080&h=1032&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "contact",
      title:
        "Для получения дополнительной информации о новом Hearing Centre ICC свяжитесь:",
      contacts: [
        {
          name: "Fiona Dermody",
          job: "ICC Hearing Centre Manager",
          email: "fiona.dermody@iccwbo.org",
        },
      ],
    },
    {
      type: "p",
      html:
        "Расположенный в спокойном районе 17<sup>го</sup> <em>округа</em>, Hearing Centre ICC строится на <em>Rue Legendre</em>, всего в нескольких минутах от ведущих парижских юридических фирм и <em>Cité judiciaire</em>, и удобно доступен от городских вокзалов и аэропортов.",
    },
    {
      type: "p",
      html:
        "Hearing Centre ICC разместится на одном уровне и предложит два набора залов слушаний и комнат для обсуждений, с возможностью расширения до третьего набора для обработки перегрузки. Современные помещения спроектированы для предоставления премиального сервиса для очных, гибридных и виртуальных слушаний с точки зрения эффективности, технологий, конфиденциальности, доступности и общего комфорта.",
    },
    {
      type: "p",
      html:
        "Здание, в котором будет размещён Hearing Centre ICC, также будет включать пятизвёздочный бутик-отель, ресторан, кафе, фитнес-центр, террасы на крыше, а также другие офисные пространства. Проект реализуется девелопером <a href=\"https://www.groupegalia.com/\" target=\"_blank\" rel=\"noreferrer noopener\">Groupe Galia</a>.",
    },
    {
      type: "p",
      html:
        "<em>Александр Г. Фессас, Генеральный секретарь Международного арбитражного суда ICC и директор Dispute Resolution Services ICC</em>, сказал:",
    },
    {
      type: "quote",
      html:
        "Предоставление превосходного сервиса для всех арбитражных и ADR-слушаний из Парижа, независимо от их институционального формата, давно было нашей целью, и мы рады, что идеальный дом для нашего нового Hearing Centre сейчас строится. Мы не можем дождаться, когда снова будем приветствовать наших гостей осенью 2024 года.",
      author:
        "Alexander G. Fessas, Secretary General of the ICC International Court of Arbitration",
    },
  ],
},
{
  slug: "law-society-of-ireland-wins-2024-icc-mediation-competition",
  taxonomy: "Медиация",
  dateLabel: "12 февраля 2024",
  title: "Law Society of Ireland выигрывает Конкурс по медиации ICC 2024",
  excerpt:
    "Команда Law Society of Ireland заняла первое место в 19-м Международном конкурсе по международной коммерческой медиации ICC, победив команду из Университета Марбурга (Германия) в финальной сессии медиации. Vrije Universiteit Amsterdam (Нидерланды) и Национальный университет Сингапура стали призёрами.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/02/icc-mediation-competition-2024-2-e1707755940682.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2024/02/icc-mediation-competition-2024-2-e1707755940682.jpg?w=1080&h=603&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Финал конкурса, прошедший в исторической лекционной аудитории Émile Boutmy в Sciences Po University в Париже, увидел, как студенческие команды столкнулись с модельной медиационной задачей о повреждённых трамваях. Сценарий был написан профессором Грегом Бондом, медиатором bond &amp; bond, а медиацию проводила независимый медиатор из Гонконга Джоди Син.",
    },
    {
      type: "p",
      html:
        "Конкурс стал первым финалом для ирландской команды и первым финалом для постоянных участников конкурса — Университета Марбурга. На сцене Law Society of Ireland представляли Аойфе О’Кэрролл и Эоин Дойл, а их коллега Клидиона Макхью поддерживала из зала.",
    },
    { type: "p", html: "Г-жа О’Кэрролл сказала:" },
    {
      type: "quote",
      html:
        "Мы очень счастливы и гордимся нашей победой. Мы вошли в конкурс без каких-либо ожиданий, так как никогда раньше не участвовали в медиационной сессии. Конкурс стал для нас обучающей кривой; думаю, прогресс виден, если сравнить нашу первую сессию с сегодняшней. В каждом раунде мы учились, получая опыт, а также наблюдая за выступлениями других команд. Конкурс по медиации настолько международный, и было интересно познакомиться с подходами из других культур. Думаю, могу сказать за нас троих, что эта неделя посеяла в нас семя страсти к медиации, и мы обязательно будем дальше изучать эту сферу. Больше чем когда-либо мы верим, что медиация — будущее.",
      author: "Ms O’Carroll",
    },
    {
      type: "p",
      html:
        "Конкурс по медиации ICC — один из крупнейших образовательных конкурсов в мире, посвящённых исключительно международной коммерческой медиации. Проводимый в Париже с 5 по 10 февраля, 46 университетских команд из 31 страны соревновались в разрешении международных коммерческих споров через медиацию. Под руководством профессиональных медиаторов и по правилам медиации ICC прошло более 75 модельных медиационных сессий. Всего 19-е издание собрало более 300 студентов и профессионалов.",
    },
    {
      type: "p",
      html:
        "Профессиональный медиатор Кимберли Шрайбер участвовала в конкурсе по медиации ICC уже 13-й год, а в этот раз была одним из пяти судей финала. Комментируя конкурс, она сказала:",
    },
    {
      type: "quote",
      html:
        "В 2024 году снова было фантастическое издание. Я приезжала сюда так много раз, и всё равно поражаюсь уровню качества и огромному объёму подготовки студентов. Это крупнейший конкурс по медиации года, и я считаю, что мы формируем будущих лидеров медиации уже сегодня. Финал был очень приятным и реалистичным. Решение было сложным: в каких-то аспектах одна команда была немного лучше, но в других аспектах — другая. В итоге, думаю, Ирландия заслужила победу.",
      author: "Kimberly Schreiber",
    },
    {
      type: "p",
      html:
        "Трофей вручил Генеральный секретарь Международного арбитражного суда ICC и директор Dispute Resolution Services ICC Александр Г. Фессас. Он сказал:",
    },
    {
      type: "quote",
      html:
        "Корпорации, государства и государственные компании не судятся, не арбитражируют и не медиируют потому, что им это нравится; они делают это потому, что хотят решение. Это инструменты в наборе инструментов, чтобы бизнес мог работать. Mediation Week так важна для ICC, потому что она в значительной степени образовательная, позволяя практикам завтрашнего дня понимать, как бизнес может вернуться к бизнесу — делать бизнес.",
      author: "Alexander G. Fessas",
    },
    { type: "p", html: "Член команды Университета Марбурга Клара Циммерман сказала:" },
    {
      type: "quote",
      html:
        "Это была очень весёлая неделя. Даже во время финала мы наслаждались каждым моментом. Жаль, что мы совсем чуть-чуть не дотянули до первого места, но Ирландия заслужила победу. Для нас путь был важнее всего. За прошлую неделю мы многому научились и встретили так много невероятных людей, что конкурс по медиации 2024 года мы будем помнить всегда.",
      author: "Klara Zimmerman",
    },
    {
      type: "p",
      html:
        "Переживите все яркие моменты конкурса по медиации ICC на <a href=\"https://twitter.com/ICCMediation\" target=\"_blank\" rel=\"noreferrer noopener\">X</a> и <a href=\"https://www.facebook.com/ICCmediation\" target=\"_blank\" rel=\"noreferrer noopener\">Facebook</a>, следуя официальному хэштегу мероприятия #ICCMW2024. Запись финальной сессии также доступна на официальном YouTube-канале ICC <a href=\"https://www.youtube.com/watch?v=3fgbknm-5RY\" target=\"_blank\" rel=\"noreferrer noopener\">@ICCWBO1919</a>.",
    },
    {
      type: "p",
      html:
        "Для получения дополнительной информации о медиационных услугах ICC посетите <a href=\"https://iccwbo.org/contact-us/dispute-resolution-services-contact-us/#anchor-contact-the-international-centre-for-adr\" target=\"_blank\" rel=\"noreferrer noopener\">ICC International Centre for ADR</a>.",
    },
  ],
},
{
  slug: "clock-is-ticking-for-future-of-e-commerce-and-digital-trade",
  taxonomy: "Торговля",
  dateLabel: "24 января 2024",
  title: "Часы тикают: будущее электронной коммерции и цифровой торговли под угрозой",
  excerpt:
    "Мораторий Всемирной торговой организации (ВТО) на таможенные пошлины на электронные передачи истекает в феврале. Если он не будет продлён, будущее электронной коммерции и цифровой торговли окажется под вопросом.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/02/icc-TradeFlow-Management.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/02/icc-TradeFlow-Management.jpg?w=1080&h=840&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Мораторий ВТО по электронной коммерции прекратит действие, если члены ВТО не договорятся о его продлении на предстоящей 13-й Министерской конференции ВТО, которая состоится в следующем месяце 26–29 февраля в Абу-Даби. ICC призывает все государства-члены ВТО продлить соглашение и выступает за его постоянное закрепление.",
    },
    {
      type: "p",
      html:
        "Без продления правительства могли бы начать экспериментировать с односторонними тарифами на всё — от программного обеспечения, цифровых платежей и облачных сервисов до данных, обеспечивающих работу популярных стриминговых сервисов, — что нарушит цифровую экономику и повысит стоимость цифровых услуг, от которых бизнес по всему миру зависит в работе и росте.",
    },
    { type: "p", html: "Генеральный секретарь ICC Джон У.Х. Дентон AO сказал:" },
    {
      type: "quote",
      html:
        "Мораторий — критически важный предохранитель, и его прекращение стало бы историческим откатом назад, который сильнее всего ударит по малому бизнесу и потребителям, повысит издержки и уменьшит доступ к знаниям, информации и цифровым инструментам. Более того, такой шаг усилил бы разрушительную тенденцию эскалации тарифов; он также мог бы потенциально устроить хаос в онлайн-экономике. Тарифы действительно могут «сломать Интернет».",
      author: "John W.H. Denton AO",
    },
    {
      type: "p",
      html:
        "Мораторий действует со Второй министерской конференции ВТО в 1998 году. С тех пор правительства соглашались продлевать его на каждой двухгодичной министерской конференции ВТО.",
    },
    {
      type: "p",
      html:
        "Хотя точного определения нет, термин «электронные передачи» обычно понимается как всё — от программного обеспечения до цифровой музыки, фильмов и видеоигр. Мораторий сыграл важную роль в развитии Интернета, удерживая тарифы вне цифрово поставляемых продуктов, услуг и контента.",
    },
    {
      type: "quote",
      html:
        "Соглашение сыграло скрытую — но жизненно важную — роль в росте интернет-экономики за последние два десятилетия, защищая Интернет от искажений и сбоев, вызванных сборами на национальных границах. Мы призываем правительства обеспечить продление моратория на MC13 в следующем месяце,",
      author: "Mr Denton",
    },
    {
      type: "p",
      html:
        "сказал г-н Дентон.",
    },
    {
      type: "p",
      html:
        "<strong>Подробнее о моратории ВТО по электронной коммерции </strong><a href=\"https://intracen.org/file/2023icc-itc-joint-icc-itc-policy-brief-edition-1-wto-moratoriumpdf\"><strong>здесь</strong></a><strong>.</strong>",
    },
  ],
},
{
  slug: "mexican-small-business-entrepreneur-shows-how-sustainability-reporting-tool-fits-the-bill",
  taxonomy: "ММСП и предпринимательство",
  dateLabel: "21 декабря 2023",
  title:
    "Предприниматель из Мексики показывает, как инструмент отчётности по устойчивому развитию подходит как нельзя лучше",
  excerpt:
    "Спрос на измерение экологического воздействия ММСП растёт, как и потребность ММСП становиться «зелёнее». Через инструмент оценки SME360X и поддерживающие инициативы, такие как UPS Green Exporters Program, ICC, Gist Impact и UPS стремятся сделать устойчивый бизнес реальностью для всех. В этой серии мы делимся историями ММСП, таких как мексиканский ремесленный текстильный бизнес Marieta Linda, которые продвигают зелёный переход в своей повседневной деятельности.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/Marieta-Linda2.png?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/Marieta-Linda2.png?w=1068&h=612&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "В Вилья-Виктория, Мексика, <a href=\"https://www.facebook.com/Marietalindamx/about\">Marieta Linda</a> — это бизнес, занимающийся продажей и дистрибуцией аксессуаров для питомцев и людей с ручной вышивкой. Компания вдохновлена цветами, традициями, креативностью и качеством мексиканских мастеров-ремесленников и посвящена сохранению этих традиций через свои аксессуары. Все их изделия вышиваются вручную женщинами народа мазахуа — одной из самых представительных коренных групп штата Мехико. Бизнес сотрудничает напрямую с сообществом ремесленников, без посредников, помогая распространять их продукцию через практики справедливой торговли.",
    },
    {
      type: "p",
      html:
        "Мария дель Кармен Эрнандес Кордова, основавшая Marieta Linda в 2019 году, увидела негативное воздействие текстильной индустрии на планету и захотела, чтобы её бизнес делал максимум возможного для более устойчивой работы. «Для меня было очень важно с самого начала учитывать не только развитие наших поставщиков, но и присоединиться к этому движению, которое, как я вижу, уже больше не является опциональным», — сказала Мария. «Я хотела сделать всё возможное, чтобы снизить наше воздействие на планету, особенно понимая, что текстильная индустрия — одна из самых загрязняющих».",
    },
    {
      type: "p",
      html:
        "С этим намерением команда Marieta Linda рассматривала разные варианты оценки экологических воздействий и познакомилась с <a href=\"https://iccwbo.org/business-solutions/services-for-small-business-and-entrepreneurship/discover-sme360x/\">SME360X</a> через Мексиканский институт предпринимательства. «Для меня было невероятно иметь возможность пользоваться им и видеть, что доступ есть у всех».",
    },
    {
      type: "figure",
      src: "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/MarietaLinda5.png",
      alt: "",
      caption:
        "Мария дель Кармен Эрнандес Кордова, основавшая Marieta Linda в 2019 году, увидела негативное воздействие текстильной индустрии на планету и захотела, чтобы её бизнес работал как можно более устойчиво.",
    },
    { type: "h3", html: "Выводы из SME360X" },
    {
      type: "p",
      html:
        "Когда Мария впервые начала использовать SME360X, её поразили инсайты, доступные на платформе. В первую очередь её внимание привлекли воздействие бизнеса по электричеству и отходам.",
    },
    {
      type: "p",
      html:
        "«Используя инструмент, нам было интересно обнаружить, что, хотя мы микро-бизнес и операция очень маленькая, мы тоже можем определённым образом снижать экологическое воздействие», — сказала Мария. «Я подумала: как мы можем уменьшить эти воздействия и управлять ими? Текстильная индустрия, к сожалению, одна из самых загрязняющих, и поэтому мы посмотрели на энергию и отходы во всех наших продуктах и сделали так, чтобы количество тканевых отходов было минимальным».",
    },
    {
      type: "p",
      html:
        "Опираясь на инсайты, полученные в процессе оценки SME360X, команда Marieta Linda сосредоточилась на водной обработке изделий, а также на материалах упаковки, сократив использование пластика и изменив способы доставки там, где это возможно. Они также начали пересматривать поставщиков, с которыми работали.",
    },
    {
      type: "p",
      html:
        "«В случае упаковки мы сейчас ищем поставщиков с меньшим воздействием и работаем с теми, кто может соответствовать требованиям, которые мы предъявляем. Мы стараемся снизить [наши воздействия]… В некоторых случаях нам выгодно доставлять самостоятельно, чтобы не использовать пенопласт и другие менее устойчивые материалы, которые иногда нужны в посылках. И мы также ищем элементы, которые можно использовать с минимальным загрязнением».",
    },
    {
      type: "p",
      html:
        "Образовательные элементы платформы SME360X также помогли ей лучше понять экологические данные и лучшие практики оценки воздействия. «Платформа действительно отличный союзник с точки зрения обучения… [она] помогает нам укреплять повседневные активности Marieta Linda», — сказала Мария.",
    },
    {
      type: "p",
      html:
        "«К сожалению, как предприниматели или даже микро-предприниматели, мы часто не знаем, какие есть нормативы, и выбираем самые распространённые варианты. «Например, я в текстильной индустрии, поэтому просто следую правилам маркировки. Но понемногу мы профессионализируем наши услуги и узнаём больше об экологии, и в процессе мы также обнаруживаем другие потребности и точки улучшения, которые находятся в рамках этих правил».",
    },
    {
      type: "figure",
      src: "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/Marieta-Linda2.png",
      alt: "",
      caption:
        "Опираясь на инсайты, полученные в процессе оценки SME360X, команда Marieta Linda сосредоточилась на водной обработке изделий, а также на материалах упаковки, сократив использование пластика и изменив способы доставки там, где это возможно.",
    },
    { type: "h3", html: "Осознание того, что ни один бизнес не остров" },
    {
      type: "p",
      html:
        "Инструмент означает, что теперь у команды Marieta Linda есть экологическая стратегия и цели на 2024 год. Мария признаёт, что этот процесс — марафон, а не спринт, но уверена, что они движутся в правильном направлении. «Теперь у марафона есть фокус, то есть мы видим, где мы добились успеха, и, возможно, можем включить туда ещё некоторые области улучшения».",
    },
    {
      type: "p",
      html:
        "Мария отмечает, что инструмент «отличен для обучения» и что он помог ей увидеть: если предприниматели вроде неё присоединятся к усилиям по снижению выбросов, это может дать глобальный эффект.",
    },
    {
      type: "p",
      html:
        "«Не бойтесь: иногда мы думаем, что маленькие вещи не влияют на окружающую среду, но помните — всё складывается и делает разницу», — сказала Мария. «Есть так много песчинок, но со временем они превращаются в гранит, становятся пляжами. Мы не должны думать только о себе и минимизировать результат наших усилий; наоборот, нужно объединяться, чтобы действительно иметь глобальное влияние».",
    },
  ],
},
{
  slug: "guest-blog-how-will-ai-impact-dispute-resolution",
  taxonomy: "Услуги по разрешению споров",
  dateLabel: "19 декабря 2023",
  title: "Гостевой блог: как ИИ повлияет на разрешение споров?",
  excerpt:
    "В этом гостевом блоге старшие управляющие директора FTI Consulting Самуэль Агирре, Леонардо Флоренсио и Картик Балисагар исследуют трансформирующий потенциал искусственного интеллекта (ИИ) в юридической индустрии. Представляя выводы на основе опроса более 100 юристов-практиков по всему миру, авторы анализируют текущий ландшафт, вызовы и медленное внедрение ИИ в разрешение споров. С фокусом на преодоление разрыва в знаниях и установление чётких руководящих принципов они освещают опасения, но также и значительные выгоды, которые может принести внедрение ИИ.",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/icc-ia-impact.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/icc-ia-impact.jpg?w=1080&h=1095&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "В одном недавнем судебном деле <a href=\"https://www.forbes.com/sites/mollybohannon/2023/06/08/lawyer-used-chatgpt-in-court-and-cited-fake-cases-a-judge-is-considering-sanctions/?sh=64e3d38a7c7f\" target=\"_blank\" rel=\"noreferrer noopener\">юристы использовали ChatGPT</a> для подготовки аргументов. Он сослался на дела, которые были полностью вымышленными, что, несомненно, стало для этих юристов большим источником неловкости. Однако потенциал правильно внедрённых ИИ-технологий — а именно способность обрабатывать неограниченные объёмы данных и выдавать результаты, не отягощённые человеческими эмоциями, — может быть трансформирующим для всей юридической индустрии. Юридические фирмы, которые смогут достичь высокого уровня компетенций в ИИ, получат огромный конкурентный перевес на десятилетия вперёд.",
    },
    {
      type: "p",
      html:
        "FTI Consulting <a href=\"https://www.fticonsulting.com/insights/reports/power-ai-navigating-paradigm-shift-dispute-resolution-services\" target=\"_blank\" rel=\"noreferrer noopener\">провела онлайн-опрос</a> более чем 100 юристов, арбитров, медиаторов и других практиков по разрешению споров по всему миру в фирмах разного размера, чтобы узнать их мнение об использовании ИИ в индустрии разрешения споров.",
    },
    {
      type: "p",
      html:
        "В юридическом сообществе мало прямых возражений против использования ИИ. Хотя потенциальные применения ИИ в услугах по разрешению споров обширны, существуют и сложности. Если опасения по поводу ИИ-инструментов не будут адресованы, использование ИИ может быть сведено к базовым задачам, и практики упустят возможности для развития более содержательных применений, которые способны существенно усилить их практику.",
    },
    {
      type: "p",
      html:
        "Несмотря на повсеместные новости об ИИ, опрос показывает, что юристы в целом мало знакомы с ИИ-инструментами. Чем выше незнакомство, тем сильнее опасения относительно точности и согласованности результатов и чрезмерной зависимости от технологии. Однако, хотя многие респонденты ожидают роста использования ИИ в ближайшие три года, немногие планируют существенные инвестиции в технологии.",
    },

    { type: "h2", html: "Как ИИ используется сегодня в разрешении споров?" },
    {
      type: "p",
      html:
        "Как и в других индустриях, внедрение ИИ в юридические услуги представляет значительную возможность для практиков — с потенциалом революционизировать индустрию споров и трансформировать то, как предоставляются юридические и экспертные услуги. Но внедрение ИИ-инструментов идёт медленно и не обходится без трудностей.",
    },
    {
      type: "p",
      html:
        "Выводы опроса показывают, что ИИ-инструменты в настоящее время не являются широко распространёнными в услугах по разрешению споров. Сейчас электронное раскрытие (e-discovery), обзор документов и подготовка черновиков — самые популярные области применения ИИ. Лишь немногие практики сообщают, что их фирмы изучали использование ИИ в других, более сложных кейсах — например, для прогнозирования исходов дел, юридических исследований или подготовки вопросов для допросов.",
    },
    {
      type: "p",
      html:
        "Только треть опрошенных говорит, что в их фирмах есть чёткие правила по использованию ИИ в спорах; крупные фирмы лидируют в создании таких руководящих принципов и рамок. Кроме того, 23% заявляют, что у них нет никаких правил или рамок по использованию ИИ в спорной практике, а ещё 25% говорят, что существующие правила и рамки не являются ясными.",
    },

    { type: "h2", html: "Как ускорить внедрение ИИ в индустрии разрешения споров?" },
    {
      type: "p",
      html:
        "Юридические практики склонны соглашаться, что ИИ-инструменты могут повышать убедительность и достоверность юридических аргументов в спорах — мнение, широко разделяемое теми, кто обладает более продвинутыми или промежуточными знаниями ИИ-технологий.",
    },
    {
      type: "p",
      html:
        "Этот оптимизм относительно ИИ отражается и в будущих применениях технологии: 64% практиков считают, что через три года ИИ произведёт революцию в индустрии споров и трансформирует способы предоставления юридических и экспертных услуг. Аналогично, более осведомлённые об ИИ респонденты чаще соглашаются с этим утверждением и выражают более сильную уверенность.",
    },
    {
      type: "p",
      html:
        "Уровни уверенности и восприятия ИИ-технологий тесно связаны со знаниями и практическим опытом, что подчёркивает необходимость преодоления разрыва в образовании в юридической профессии. Практики, которые идентифицируют себя как advanced/intermediate, и те, чьи фирмы уже использовали ИИ в спорах, оценивают свой уровень уверенности значительно выше, чем их коллеги с меньшим опытом. Более глубокие знания и контакт с ИИ-технологиями могут повысить уверенность практиков и помочь успешнее интегрировать ИИ-решения. В итоге, чтобы реализовать полный потенциал ИИ, практикам нужно закрыть образовательный разрыв, а юридическим фирмам — установить чёткие правила использования технологии.",
    },

    { type: "h2", html: "Кто выигрывает от ИИ в разрешении споров?" },
    {
      type: "p",
      html:
        "Треть практиков считают, что ИИ имеет значительный потенциал для улучшения доступа к правосудию. Те, кто имеет больше знаний и опыта в ИИ через свои фирмы, значительно выше оценивают потенциал ИИ — что показывает: более продвинутое понимание и контакт с технологией коррелируют с большим оптимизмом относительно её трансформирующего влияния на доступ к правосудию.",
    },
    {
      type: "p",
      html:
        "Опрошенные практики считают, что больше всего от ИИ в разрешении споров выиграют юридические фирмы, затем — стороны спора и in-house юридические подразделения. Практики с advanced/intermediate знаниями по сравнению с новичками значительно чаще признают выгоды ИИ для своих фирм (90% против 66%). Аналогично, фирмы с опытом использования ИИ в спорах чаще признают эти выгоды, чем фирмы без такого опыта (90% против 70%).",
    },
    {
      type: "p",
      html:
        "Практики, чьи компании уже использовали ИИ в спорах, чаще признают его множественные преимущества, особенно в обработке больших объёмов информации (85% против 57%) и автоматизации ручных процессов (54% против 20%) по сравнению с теми, кто не использовал ИИ.",
    },
    {
      type: "p",
      html:
        "<em>Дисклеймер: мнения, выраженные здесь, принадлежат автору(ам) и не обязательно отражают взгляды FTI Consulting, Inc., её руководства, дочерних компаний, аффилированных лиц или других профессионалов. Аналогично, содержание этой статьи не отражает официальные взгляды Международной торговой палаты.</em>",
    },
    {
      type: "p",
      html:
        "<em>FTI Consulting, Inc., включая её дочерние компании и аффилированные лица, является консалтинговой компанией и не является сертифицированной аудиторской фирмой или юридической фирмой. </em><em>©2023 FTI Consulting, Inc. Все права защищены. </em><a href=\"https://urldefense.proofpoint.com/v2/url?u=http-3A__www.fticonsulting.com&amp;d=DwMFaQ&amp;c=L5E2d05je37i-dadkViuXA&amp;r=QKv_ztlhAoISx5DIJ55qTCUpcAGkAe44235HRYxlar4&amp;m=DBgpcjOgKK5apq64hkKQ7diMBxm0BkT1UbJ2GQBGEbA&amp;s=FWccQaD96n45ervQOus4jHw3IN_z1dcIboij4Y45f1U&amp;e=\" target=\"_blank\" rel=\"noreferrer noopener\"><em>fticonsulting.com</em></a><em> </em>",
    },
  ],
},
{
  slug: "eu-directive-on-combatting-late-payment-and-its-unintended-consequences-on-the-real-economy",
  taxonomy: "Банковское дело и финансы",
  dateLabel: "11 декабря 2023",
  title:
    "Директива ЕС по борьбе с просроченными платежами и её непреднамеренные последствия для реальной экономики",
  excerpt: "Международная торговая палата («ICC») — институциональный представитель более чем 45 миллионов компаний в более чем 170 странах — поддерживает инициативы, направленные на формирование культуры надёжных и своевременных платежей. Хотя основная цель директивы заслуживает одобрения, более внимательное рассмотрение выявляет ряд непреднамеренных последствий, которые вызывают обеспокоенность относительно её эффективности и более широких воздействий на договорную свободу, гибкость переговоров и жизнеспособность малых и средних предприятий (SMEs).",
  cover: {
    listSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/icc-european-union-flag.jpg?w=400&h=260&crop=1",
    heroSrc:
      "https://iccwbo.org/wp-content/uploads/sites/3/2023/12/icc-european-union-flag.jpg?w=1080&h=1260&crop=1",
    alt: "",
  },
  blocks: [
    {
      type: "p",
      html:
        "Международная торговая палата («ICC») — институциональный представитель более чем 45 миллионов компаний в более чем 170 странах — поддерживает инициативы, направленные на формирование культуры надёжных и своевременных платежей. Хотя основная цель директивы заслуживает одобрения, более внимательное рассмотрение выявляет ряд непреднамеренных последствий, которые вызывают обеспокоенность относительно её эффективности и более широких воздействий на договорную свободу, гибкость переговоров и жизнеспособность малых и средних предприятий (SMEs).",
    },
    { type: "spacer", height: 30 },
    {
      type: "p",
      html:
        "<strong>1. Ограничение договорной свободы и гибкости переговоров</strong>",
    },
    {
      type: "p",
      html:
        "Директива вводит стандартное ограничение по срокам оплаты, снижая гибкость компаний в согласовании условий, подходящих их уникальным обстоятельствам. Такой подход «один размер для всех» игнорирует разнообразие отраслей, бизнес-моделей и финансовых возможностей SMEs. Тем самым он непреднамеренно посягает на фундаментальное право свободы договора, препятствуя естественным переговорам, которые могли бы лучше соответствовать интересам сторон.",
    },
    { type: "spacer", height: 30 },
    { type: "p", html: "<strong>2. Влияние на SMEs как покупателей</strong>" },
    {
      type: "p",
      html:
        "SMEs, часто работающие с более узкой маржой, сталкиваются с трудностями при соблюдении предписанных периодов оплаты. Вводя жёсткие сроки, директива может создавать нагрузку для SMEs как покупателей, потенциально ограничивая их способность эффективно управлять денежными потоками и распределять ресурсы.",
    },
    { type: "spacer", height: 30 },
    { type: "p", html: "<strong>3. Влияние на ликвидность и доступ к финансированию</strong>" },
    {
      type: "p",
      html:
        "Жёсткость сроков оплаты, предусмотренных директивой, может усугублять проблемы ликвидности у SMEs. Отложенный приток средств нарушает денежные потоки, мешая инвестировать в инновации, рост и занятость. Более того, это может привести к усилению зависимости от внешнего финансирования, возможно, по более высокой цене, поскольку задержки платежей подрывают финансовую устойчивость таких компаний.",
    },
    { type: "spacer", height: 30 },
    { type: "p", html: "<strong>4. Акцент на просроченных платежах государства бизнесу</strong>" },
    {
      type: "p",
      html:
        "Также важно напомнить о платежах государства бизнесу, которые зачастую создают больше просрочек, чем обычные платежи «бизнес-бизнес».",
    },
    {
      type: "p",
      html:
        "Рекомендация ICC заключается в том, чтобы избегать жёсткого «потолка» по срокам оплаты и вместо этого предоставить бизнесу свободу согласовывать условия оплаты (если они не являются грубо несправедливыми) как фундаментальное право.",
    },
    {
      type: "p",
      html:
        "Ограничение по дням должно применяться только при отсутствии соглашения между сторонами.",
    },
    {
      type: "p",
      html:
        "Хотя Директива ЕС о просроченных платежах решает критически важную проблему задержек оплат, её непреднамеренные последствия рискуют подорвать именно те компании, которые она стремится защитить. Нужен более нюансированный подход, который учитывает разнообразие ландшафта SMEs, способствует гибкости переговоров и поддерживает, а не ограничивает, их финансовое здоровье — это критично для устойчивого экономического роста и развития.",
    },
    {
      type: "p",
      html:
        "Это заявление призвано подчеркнуть опасения и предложить практические рекомендации по устранению непреднамеренных последствий Директивы ЕС о просроченных платежах. Корректировки или дополнения могут быть внесены, чтобы подчеркнуть конкретные пункты или точнее согласовать текст с вашей позицией.",
    },
    {
      type: "p",
      html:
        "ICC остаётся доступной для предоставления дополнительных разъяснений по пунктам, изложенным выше.",
    },
    { type: "spacer", height: 30 },
    { type: "p", html: "" },
  ],
},

];
